// 星座数据
// 名称、拉丁名称、id、星座的星星、连接关系、星座名的坐标、星座图标的坐标
// 星星的颜色、赤经范围、赤纬范围、面积、所含星数、最佳观测月份
// color无用了，可删除

let constellations = [
  {
    "name": "白羊座",
    "latinName": "Aries",
    "id": 1,
    "starsOrigin": [
      {
        "name": "41白羊座",
        "position": [
          2.833063,
          27.260507,
          50.7872
        ]
      },
      {
        "name": "娄宿三",
        "position": [
          2.119555,
          23.462423,
          20.1776
        ]
      },
      {
        "name": "娄宿一",
        "position": [
          1.910668,
          20.808035,
          17.9856
        ]
      },
      {
        "name": "娄宿二",
        "position": [
          1.89217,
          19.293852,
          50.3018
        ]
      }
    ],
    "connRel": [
      [
        101,
        102
      ],
      [
        102,
        103
      ],
      [
        103,
        104
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": '娄宿三',
    "labelPositionIdx": 1,
    "raRange": "1时46分~3时30分",
    "decRange": "10.2°~31.4°",
    "symbol": "白牡羊",
    "lucida": "白羊座α(娄宿三)",
    "area": "441km²",
    "containedStars": "67",
    "bestObs": "10-12月",
  },
  {
    "name": "金牛座",
    "latinName": "Taurus",
    "id": 2,
    "starsOrigin": [
      {
        "name": "五车五",
        "position": [
          5.438198,
          28.60745,
          41.0509
        ]
      },
      {
        "name": "τ金牛座",
        "position": [
          4.704084,
          22.956926,
          122.1001
        ]
      },
      {
        "name": "毕宿一",
        "position": [
          4.476943,
          19.180431,
          44.964
        ]
      },
      {
        "name": "毕宿五",
        "position": [
          4.598677,
          16.509301,
          20.4332
        ]
      },
      {
        "name": "θ1金牛座",
        "position": [
          4.476248,
          15.962181,
          47.3261
        ]
      },
      {
        "name": "毕宿四",
        "position": [
          4.329889,
          15.627642,
          49.5295
        ]
      },
      {
        "name": "毕宿三",
        "position": [
          4.382247,
          17.542514,
          47.7099
        ]
      },
      {
        "name": "昴宿七",
        "position": [
          3.819373,
          24.053415,
          117.2333
        ]
      },
      {
        "name": "λ金牛座",
        "position": [
          4.011338,
          12.490347,
          148.368
        ]
      },
      {
        "name": "ξ金牛座",
        "position": [
          3.45282,
          9.73268,
          64.1026
        ]
      },
      {
        "name": "ζ金牛座",
        "position": [
          5.627413,
          21.142549,
          136.4256
        ]
      }
    ],
    "connRel": [
      [
        201,
        202
      ],
      [
        202,
        203
      ],
      [
        203,
        204
      ],
      [
        204,
        205
      ],
      [
        205,
        206
      ],
      [
        206,
        207
      ],
      [
        207,
        208
      ],
      [
        207,
        203
      ],
      [
        204,
        211
      ],
      [
        206,
        209
      ],
      [
        209,
        210
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": '毕宿三',
    "labelPositionIdx": 1,
    "raRange": "3时23分~5时55分",
    "decRange": "-1.9°~30.7°",
    "symbol": "牛",
    "lucida": "金牛座α(毕宿五)",
    "area": "797km²",
    "containedStars": "130",
    "bestObs": "11-1月"
  },
  {
    "name": "双子座",
    "latinName": "Gemini",
    "id": 3,
    "starsOrigin": [
      {
        "name": "钺@1",
        "position": [
          7.428779,
          27.79808,
          36.9004
        ]
      },
      {
        "name": "钺@2",
        "position": [
          6.247961,
          22.506799,
          117.9245
        ]
      },
      {
        "name": "井宿一",
        "position": [
          6.382673,
          22.513586,
          71.0227
        ]
      },
      {
        "name": "井宿五",
        "position": [
          6.732202,
          25.131124,
          259.0674
        ]
      },
      {
        "name": "τ双子座",
        "position": [
          7.185659,
          30.245163,
          98.4252
        ]
      },
      {
        "name": "钺@3",
        "position": [
          6.068671,
          23.263341,
          47.5511
        ]
      },
      {
        "name": "υ双子座",
        "position": [
          7.598708,
          26.895741,
          83.0565
        ]
      },
      {
        "name": "天樽二",
        "position": [
          7.335383,
          21.98232,
          18.5391
        ]
      },
      {
        "name": "λ双子座",
        "position": [
          7.30155,
          16.540383,
          30.931
        ]
      },
      {
        "name": "井宿四",
        "position": [
          6.754824,
          12.895591,
          17.9986
        ]
      },
      {
        "name": "ν双子座",
        "position": [
          6.482719,
          20.212133,
          166.9449
        ]
      },
      {
        "name": "θ双子座",
        "position": [
          6.879816,
          33.961254,
          57.971
        ]
      },
      {
        "name": "北河二",
        "position": [
          7.576634,
          31.888276,
          15.5958
        ]
      },
      {
        "name": "北河三",
        "position": [
          7.755277,
          28.026199,
          10.3584
        ]
      },
      {
        "name": "κ双子座",
        "position": [
          7.740793,
          24.397993,
          43.3463
        ]
      },
      {
        "name": "井宿三",
        "position": [
          7.068481,
          20.570297,
          421.9409
        ]
      },
      {
        "name": "井宿七",
        "position": [
          6.628528,
          16.399252,
          33.5121
        ]
      }
    ],
    "connRel": [
      [
        306,
        302
      ],
      [
        302,
        303
      ],
      [
        303,
        304
      ],
      [
        304,
        305
      ],
      [
        305,
        301
      ],
      [
        301,
        307
      ],
      [
        307,
        308
      ],
      [
        308,
        309
      ],
      [
        309,
        310
      ],
      [
        304,
        311
      ],
      [
        305,
        312
      ],
      [
        305,
        313
      ],
      [
        307,
        314
      ],
      [
        307,
        315
      ],
      [
        308,
        316
      ],
      [
        316,
        317
      ]
    ],
    "iconSize": { width: 5000, height: 10000 },
    "iconPosition": '钺@1',
    "labelPositionIdx": 1,
    "raRange": "6时04分~8时00分",
    "decRange": "10.2°~35.3°",
    "symbol": "双胞胎",
    "lucida": "双子座β(北河三)",
    "area": "514km²",
    "containedStars": "80",
    "bestObs": "1-2月"
  },
  {
    "name": "巨蟹座",
    "latinName": "Cancer",
    "id": 4,
    "starsOrigin": [
      {
        "name": "柳宿增十",
        "position": [
          8.275256,
          9.185545,
          93.0233
        ]
      },
      {
        "name": "柳宿增三",
        "position": [
          8.974784,
          11.857701,
          57.7367
        ]
      },
      {
        "name": "鬼宿四",
        "position": [
          8.74475,
          18.154309,
          40.032
        ]
      },
      {
        "name": "鬼宿三",
        "position": [
          8.721431,
          21.468501,
          55.5556
        ]
      },
      {
        "name": "ι巨蟹座",
        "position": [
          8.777773,
          28.765059,
          85.5432
        ]
      }
    ],
    "connRel": [
      [
        402,
        403
      ],
      [
        403,
        404
      ],
      [
        404,
        405
      ],
      [
        403,
        401
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": '鬼宿三',
    "labelPositionIdx": 2,
    "raRange": "7时55分~9时22分",
    "decRange": "7°~33.2°",
    "symbol": "蟹",
    "lucida": "巨蟹座β(柳宿增十)",
    "area": "507km²",
    "containedStars": "76",
    "bestObs": "1-3月"
  },
  {
    "name": "狮子座",
    "latinName": "Leo",
    "id": 5,
    "starsOrigin": [
      {
        "name": "轩辕九",
        "position": [
          9.764188,
          23.774255,
          75.643
        ]
      },
      {
        "name": "轩辕十",
        "position": [
          9.879398,
          26.006951,
          38.0518
        ]
      },
      {
        "name": "轩辕十一",
        "position": [
          10.278171,
          23.417311,
          84.0336
        ]
      },
      {
        "name": "轩辕十二",
        "position": [
          10.332873,
          19.841489,
          39.8883
        ]
      },
      {
        "name": "η狮子座",
        "position": [
          10.122209,
          16.762664,
          389.1051
        ]
      },
      {
        "name": "轩辕十四",
        "position": [
          10.139532,
          11.967207,
          24.3132
        ]
      },
      {
        "name": "西次相、太微右垣四",
        "position": [
          11.237335,
          15.42957,
          50.6073
        ]
      },
      {
        "name": "五帝座一",
        "position": [
          11.817663,
          14.57206,
          10.9999
        ]
      },
      {
        "name": "西上相、太微右垣五",
        "position": [
          11.235138,
          20.523717,
          17.9147
        ]
      }
    ],
    "connRel": [
      [
        501,
        502
      ],
      [
        502,
        503
      ],
      [
        503,
        504
      ],
      [
        504,
        509
      ],
      [
        509,
        508
      ],
      [
        508,
        507
      ],
      [
        507,
        506
      ],
      [
        506,
        505
      ],
      [
        505,
        504
      ],
      [
        507,
        509
      ]
    ],
    "iconSize": { width: 7000, height: 7000 },
    "iconPosition": '轩辕十二',
    "labelPositionIdx": 1,
    "raRange": "9时22分~11时52分",
    "decRange": "-0.4°~33.2°",
    "symbol": "狮子",
    "lucida": "狮子座α(轩辕十四)",
    "area": "947km²",
    "containedStars": "92",
    "bestObs": "3-4月"
  },
  {
    "name": "处女座",
    "latinName": "Virgo",
    "id": 6,
    "starsOrigin": [
      {
        "name": "右执法、太微右垣一",
        "position": [
          11.844922,
          1.764718,
          10.929
        ]
      },
      {
        "name": "左执法、太微左垣一",
        "position": [
          12.331766,
          -0.666803,
          81.367
        ]
      },
      {
        "name": "东上相、太微左垣二",
        "position": [
          12.694345,
          -1.449375,
          11.685
        ]
      },
      {
        "name": "处女座δ",
        "position": [
          12.92667,
          3.397469,
          61.93348
        ]
      },
      {
        "name": "太微左垣七、东次将",
        "position": [
          13.036278,
          10.95915,
          33.6022
        ]
      },
      {
        "name": "角宿一",
        "position": [
          13.419883,
          -11.161322,
          76.5697
        ]
      },
      {
        "name": "κ处女座",
        "position": [
          14.214929,
          -10.273702,
          78.125
        ]
      },
      {
        "name": "角宿二",
        "position": [
          13.57822,
          -0.59582,
          22.7118
        ]
      },
      {
        "name": "亢宿二",
        "position": [
          14.266908,
          -6.000547,
          22.237
        ]
      },
      {
        "name": "亢宿增七",
        "position": [
          14.717673,
          -5.658207,
          18.2715
        ]
      },
      {
        "name": "τ处女座",
        "position": [
          14.027443,
          1.544532,
          68.9655
        ]
      },
      {
        "name": "109处女座",
        "position": [
          14.770812,
          1.892885,
          41.2371
        ]
      }
    ],
    "connRel": [
      [
        605,
        604
      ],
      [
        604,
        603
      ],
      [
        603,
        608
      ],
      [
        608,
        611
      ],
      [
        611,
        612
      ],
      [
        608,
        609
      ],
      [
        609,
        610
      ],
      [
        603,
        602
      ],
      [
        602,
        601
      ],
      [
        603,
        606
      ],
      [
        606,
        607
      ]
    ],
    "iconSize": { width: 9000, height: 9000 },
    "iconPosition": '角宿二',
    "labelPositionIdx": 1,
    "raRange": "11时37分~15时11分",
    "decRange": "-22°~14°",
    "symbol": "女子",
    "lucida": "室女座α(角宿一)",
    "area": "1294km²",
    "containedStars": "96",
    "bestObs": "4-6月"
  },
  {
    "name": "天秤座",
    "latinName": "Libra",
    "id": 7,
    "starsOrigin": [
      {
        "name": "氐宿三",
        "position": [
          15.592105,
          -14.789537,
          50.025
        ]
      },
      {
        "name": "氐宿四",
        "position": [
          15.283449,
          -9.382917,
          56.7537
        ]
      },
      {
        "name": "氐宿一",
        "position": [
          14.847977,
          -16.041778,
          23.2396
        ]
      },
      {
        "name": "折威七",
        "position": [
          15.067839,
          -25.281965,
          88.4173
        ]
      }
    ],
    "connRel": [
      [
        701,
        702
      ],
      [
        702,
        703
      ],
      [
        703,
        704
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 1,
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "14时21分~16时02分",
    "decRange": "-0.4°~-30°",
    "symbol": "天平",
    "lucida": "天秤座β(氐宿四)",
    "area": "538km²",
    "containedStars": "46",
    "bestObs": "5-6月"
  },
  {
    "name": "天蝎座",
    "latinName": "Scorpius",
    "id": 8,
    "starsOrigin": [
      {
        "name": "尾宿八",
        "position": [
          17.560145,
          -37.103821,
          175.1313
        ]
      },
      {
        "name": "κ天蝎座",
        "position": [
          17.708132,
          -39.029983,
          148.1481
        ]
      },
      {
        "name": "ι1天蝎座",
        "position": [
          17.793078,
          -40.126997,
          591.716
        ]
      },
      {
        "name": "尾宿五",
        "position": [
          17.62198,
          -42.997824,
          92.081
        ]
      },
      {
        "name": "η天蝎座",
        "position": [
          17.202552,
          -43.239189,
          22.5276
        ]
      },
      {
        "name": "ζ2天蝎座",
        "position": [
          16.909731,
          -42.361313,
          40.568
        ]
      },
      {
        "name": "μ1天蝎座",
        "position": [
          16.864509,
          -38.04738,
          153.6098
        ]
      },
      {
        "name": "ε天蝎座",
        "position": [
          16.83608,
          -34.293232,
          19.5351
        ]
      },
      {
        "name": "τ天蝎座",
        "position": [
          16.598043,
          -28.216016,
          145.3488
        ]
      },
      {
        "name": "心宿二",
        "position": [
          16.490128,
          -26.432002,
          169.7793
        ]
      },
      {
        "name": "π天蝎座",
        "position": [
          15.980865,
          -26.114105,
          179.5332
        ]
      },
      {
        "name": "房宿三",
        "position": [
          16.005557,
          -22.62171,
          150.6024
        ]
      },
      {
        "name": "房宿四",
        "position": [
          16.09062,
          -19.805453,
          123.9157
        ]
      }
    ],
    "connRel": [
      [
        801,
        802
      ],
      [
        802,
        803
      ],
      [
        803,
        804
      ],
      [
        804,
        805
      ],
      [
        805,
        806
      ],
      [
        806,
        807
      ],
      [
        807,
        808
      ],
      [
        808,
        809
      ],
      [
        809,
        810
      ],
      [
        810,
        811
      ],
      [
        810,
        812
      ],
      [
        810,
        813
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'ε天蝎座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "15时47分~17时59分",
    "decRange": "-8.4°~-45.5°",
    "symbol": "蝎子",
    "lucida": "天蝎座α(心宿二)",
    "area": "497km²",
    "containedStars": "47",
    "bestObs": "6-7月"
  },
  {
    "name": "射手座",
    "latinName": "Sagittarius",
    "id": 9,
    "starsOrigin": [
      {
        "name": "天渊二@1",
        "position": [
          19.377303,
          -44.458965,
          96.1538
        ]
      },
      {
        "name": "η射手座",
        "position": [
          18.293793,
          -36.761686,
          44.7427
        ]
      },
      {
        "name": "ι射手座",
        "position": [
          19.921026,
          -41.868288,
          55.7414
        ]
      },
      {
        "name": "天渊三",
        "position": [
          19.398103,
          -40.61594,
          55.7414
        ]
      },
      {
        "name": "箕宿三",
        "position": [
          18.402868,
          -34.384616,
          43.9367
        ]
      },
      {
        "name": "箕宿一",
        "position": [
          18.096803,
          -30.424091,
          29.7
        ]
      },
      {
        "name": "箕宿二",
        "position": [
          18.3499,
          -29.828103,
          106.6098
        ]
      },
      {
        "name": "斗宿二",
        "position": [
          18.466179,
          -25.4217,
          23.9693
        ]
      },
      {
        "name": "φ射手座",
        "position": [
          18.76094,
          -26.990778,
          73.3676
        ]
      },
      {
        "name": "斗宿四",
        "position": [
          18.92109,
          -26.296722,
          69.8324
        ]
      },
      {
        "name": "斗宿六",
        "position": [
          19.043532,
          -29.880105,
          27.0416
        ]
      },
      {
        "name": "τ射手座",
        "position": [
          19.11567,
          -27.670423,
          37.2856
        ]
      },
      {
        "name": "ο射手座",
        "position": [
          19.07805,
          -21.741496,
          43.554
        ]
      },
      {
        "name": "43射手座",
        "position": [
          19.293911,
          -18.952908,
          147.7105
        ]
      },
      {
        "name": "ρ1射手座",
        "position": [
          19.361211,
          -17.847197,
          38.9257
        ]
      },
      {
        "name": "55射手座",
        "position": [
          19.708648,
          -16.123996,
          54.3183
        ]
      },
      {
        "name": "61射手座",
        "position": [
          19.965842,
          -15.49149,
          81.4332
        ]
      },
      {
        "name": "52射手座",
        "position": [
          19.611786,
          -24.883623,
          58.1395
        ]
      },
      {
        "name": "62射手座",
        "position": [
          20.044299,
          -27.709845,
          137.5516
        ]
      },
      {
        "name": "θ1射手座",
        "position": [
          19.995605,
          -35.276305,
          158.9825
        ]
      },
      {
        "name": "μ射手座",
        "position": [
          18.229392,
          -21.058834,
          100000
        ]
      },
      {
        "name": "3射手座",
        "position": [
          17.792674,
          -27.830788,
          302.1148
        ]
      }
    ],
    "connRel": [
      [
        901,
        902
      ],
      [
        902,
        905
      ],
      [
        905,
        906
      ],
      [
        906,
        922
      ],
      [
        922,
        921
      ],
      [
        921,
        907
      ],
      [
        907,
        908
      ],
      [
        908,
        909
      ],
      [
        909,
        911
      ],
      [
        911,
        912
      ],
      [
        912,
        910
      ],
      [
        910,
        913
      ],
      [
        913,
        914
      ],
      [
        914,
        915
      ],
      [
        915,
        916
      ],
      [
        916,
        917
      ],
      [
        912,
        918
      ],
      [
        918,
        919
      ],
      [
        907,
        906
      ],
      [
        909,
        910
      ],
      [
        911,
        905
      ],
      [
        905,
        904
      ],
      [
        904,
        903
      ]
    ],
    "iconSize": { width: 7000, height: 7000 },
    "iconPosition": 'φ射手座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "17时43分~20时28分",
    "decRange": "-11.9°~-45.5°",
    "symbol": "人马座",
    "lucida": "人马座ε(箕宿三)",
    "area": "867km²",
    "containedStars": "69",
    "bestObs": "7-8月"
  },
  {
    "name": "摩羯座",
    "latinName": "Capricornus",
    "id": 10,
    "starsOrigin": [
      {
        "name": "牛宿二",
        "position": [
          20.300904,
          -12.544852,
          32.4465
        ]
      },
      {
        "name": "牛宿一",
        "position": [
          20.350187,
          -14.781367,
          100.2004
        ]
      },
      {
        "name": "ρ摩羯座",
        "position": [
          20.481004,
          -17.813687,
          30.2663
        ]
      },
      {
        "name": "ψ摩羯座",
        "position": [
          20.76826,
          -25.270898,
          14.6778
        ]
      },
      {
        "name": "ω摩羯座",
        "position": [
          20.863692,
          -26.919133,
          258.3979
        ]
      },
      {
        "name": "ζ摩羯座",
        "position": [
          21.444452,
          -22.411332,
          118.2033
        ]
      },
      {
        "name": "κ摩羯座",
        "position": [
          21.710973,
          -18.866323,
          90.1713
        ]
      },
      {
        "name": "垒壁阵四",
        "position": [
          21.784011,
          -16.127286,
          11.8666
        ]
      },
      {
        "name": "垒壁阵三",
        "position": [
          21.668181,
          -16.662308,
          48.1464
        ]
      },
      {
        "name": "θ摩羯座",
        "position": [
          21.099118,
          -17.232861,
          49.7265
        ]
      }
    ],
    "connRel": [
      [
        1001,
        1002
      ],
      [
        1002,
        1003
      ],
      [
        1003,
        1004
      ],
      [
        1004,
        1005
      ],
      [
        1005,
        1006
      ],
      [
        1006,
        1007
      ],
      [
        1007,
        1008
      ],
      [
        1008,
        1009
      ],
      [
        1009,
        1010
      ],
      [
        1010,
        1002
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'θ摩羯座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "20时06分~21时59分",
    "decRange": "-8.4°~-27.7°",
    "symbol": "山羊",
    "lucida": "摩羯座δ(垒壁阵四)",
    "area": "414km²",
    "containedStars": "49",
    "bestObs": "8-9月"
  },
  {
    "name": "水瓶座",
    "latinName": "Aquarius",
    "id": 11,
    "starsOrigin": [
      {
        "name": "女宿一",
        "position": [
          20.794598,
          -9.495776,
          63.6943
        ]
      },
      {
        "name": "虚宿一@2",
        "position": [
          21.525982,
          -5.571172,
          164.7446
        ]
      },
      {
        "name": "危宿一",
        "position": [
          22.096399,
          -0.319851,
          160.5136
        ]
      },
      {
        "name": "坟墓二",
        "position": [
          22.360938,
          -1.387331,
          50.2008
        ]
      },
      {
        "name": "ζ1水瓶座",
        "position": [
          22.480531,
          -0.019972,
          28.169
        ]
      },
      {
        "name": "η水瓶座",
        "position": [
          22.589272,
          -0.117498,
          51.4668
        ]
      },
      {
        "name": "Hydor",
        "position": [
          22.87691,
          -7.579599,
          118.0638
        ]
      },
      {
        "name": "ψ1水瓶座",
        "position": [
          23.264859,
          -9.087737,
          45.9348
        ]
      },
      {
        "name": "98水瓶座",
        "position": [
          23.382842,
          -20.10058,
          50.1002
        ]
      },
      {
        "name": "泣二",
        "position": [
          22.280565,
          -7.78329,
          57.4713
        ]
      },
      {
        "name": "58水瓶座",
        "position": [
          22.528144,
          -10.905561,
          71.582
        ]
      },
      {
        "name": "τ2水瓶座",
        "position": [
          22.826528,
          -13.592632,
          97.371
        ]
      },
      {
        "name": "羽林军二十六",
        "position": [
          22.910837,
          -15.82082,
          49.2368
        ]
      },
      {
        "name": "88水瓶座",
        "position": [
          23.157443,
          -21.17241,
          82.9876
        ]
      },
      {
        "name": "ι水瓶座",
        "position": [
          22.107286,
          -13.869679,
          53.7057
        ]
      }
    ],
    "connRel": [
      [
        1101,
        1102
      ],
      [
        1102,
        1103
      ],
      [
        1103,
        1104
      ],
      [
        1104,
        1105
      ],
      [
        1105,
        1106
      ],
      [
        1106,
        1107
      ],
      [
        1107,
        1108
      ],
      [
        1108,
        1109
      ],
      [
        1103,
        1110
      ],
      [
        1110,
        1111
      ],
      [
        1111,
        1112
      ],
      [
        1112,
        1113
      ],
      [
        1113,
        1114
      ],
      [
        1110,
        1115
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": '泣二',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "20时38分~23时56分",
    "decRange": "-3.3°~-24.9°",
    "symbol": "宝瓶",
    "lucida": "宝瓶座β(虚宿一)",
    "area": "980km²",
    "containedStars": "97",
    "bestObs": "8-10月"
  },
  {
    "name": "双鱼座",
    "latinName": "Pisces",
    "id": 12,
    "starsOrigin": [
      {
        "name": "τ双鱼座",
        "position": [
          1.194342,
          30.089638,
          51.7598
        ]
      },
      {
        "name": "υ双鱼座",
        "position": [
          1.324443,
          27.264059,
          94.4287
        ]
      },
      {
        "name": "χ双鱼座",
        "position": [
          1.190894,
          21.03465,
          117.6471
        ]
      },
      {
        "name": "η双鱼座",
        "position": [
          1.524725,
          15.345823,
          107.1811
        ]
      },
      {
        "name": "右更四",
        "position": [
          1.756564,
          9.157736,
          85.6898
        ]
      },
      {
        "name": "外屏七",
        "position": [
          2.033889,
          2.7636,
          199.9041
        ]
      },
      {
        "name": "ξ双鱼座",
        "position": [
          1.892597,
          3.187536,
          54.9149
        ]
      },
      {
        "name": "ν双鱼座",
        "position": [
          1.690526,
          5.487613,
          111.3586
        ]
      },
      {
        "name": "μ双鱼座",
        "position": [
          1.503087,
          6.14382,
          93.1966
        ]
      },
      {
        "name": "ε双鱼座",
        "position": [
          1.049058,
          7.890135,
          55.7414
        ]
      },
      {
        "name": "δ双鱼座",
        "position": [
          0.811373,
          7.585079,
          95.4198
        ]
      },
      {
        "name": "ω双鱼座",
        "position": [
          23.988525,
          6.863321,
          31.9898
        ]
      },
      {
        "name": "ι双鱼座",
        "position": [
          23.665844,
          5.626292,
          13.7137
        ]
      },
      {
        "name": "λ双鱼座",
        "position": [
          23.700779,
          1.780041,
          32.6904
        ]
      },
      {
        "name": "κ双鱼座",
        "position": [
          23.448876,
          1.255608,
          47.0588
        ]
      },
      {
        "name": "γ双鱼座",
        "position": [
          23.286094,
          3.282289,
          42.3012
        ]
      },
      {
        "name": "7双鱼座",
        "position": [
          23.339051,
          5.381307,
          132.626
        ]
      },
      {
        "name": "θ双鱼座",
        "position": [
          23.466138,
          6.378992,
          45.5373
        ]
      },
      {
        "name": "霹雳一",
        "position": [
          23.064615,
          3.820045,
          125.1564
        ]
      },
      {
        "name": "φ双鱼座",
        "position": [
          1.229152,
          24.583713,
          136.7989
        ]
      }
    ],
    "connRel": [
      [
        1201,
        1202
      ],
      [
        1202,
        1220
      ],
      [
        1220,
        1203
      ],
      [
        1203,
        1204
      ],
      [
        1204,
        1205
      ],
      [
        1205,
        1206
      ],
      [
        1206,
        1207
      ],
      [
        1207,
        1208
      ],
      [
        1208,
        1209
      ],
      [
        1209,
        1210
      ],
      [
        1210,
        1211
      ],
      [
        1211,
        1212
      ],
      [
        1212,
        1213
      ],
      [
        1213,
        1214
      ],
      [
        1214,
        1215
      ],
      [
        1215,
        1216
      ],
      [
        1216,
        1217
      ],
      [
        1217,
        1218
      ],
      [
        1218,
        1213
      ],
      [
        1216,
        1219
      ]
    ],
    "iconSize": { width: 8000, height: 8000 },
    "iconPosition": 'ε双鱼座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "22时51分~2时07分",
    "decRange": "-6.7°~33.2°",
    "symbol": "鱼",
    "lucida": "双鱼座η(右更二)",
    "area": "889km²",
    "containedStars": "86",
    "bestObs": "9-11月"
  },
  {
    "name": "长蛇座",
    "latinName": "Hydra",
    "id": 13,
    "starsOrigin": [
      {
        "name": "γ长蛇座",
        "position": [
          13.315359,
          -23.171512,
          41.0341
        ]
      },
      {
        "name": "ψ长蛇座",
        "position": [
          13.150909,
          -23.11807,
          70.9723
        ]
      },
      {
        "name": "β长蛇座",
        "position": [
          11.881813,
          -33.908124,
          94.9668
        ]
      },
      {
        "name": "ν长蛇座",
        "position": [
          10.827079,
          -16.193648,
          44.0723
        ]
      },
      {
        "name": "μ长蛇座",
        "position": [
          10.434842,
          -16.83629,
          71.7875
        ]
      },
      {
        "name": "λ长蛇座",
        "position": [
          10.176467,
          -12.354083,
          34.5066
        ]
      },
      {
        "name": "υ1长蛇座",
        "position": [
          9.85797,
          -14.846603,
          80.9061
        ]
      },
      {
        "name": "星宿一",
        "position": [
          9.45979,
          -8.658603,
          55.2792
        ]
      },
      {
        "name": "τ1长蛇座",
        "position": [
          9.485805,
          -2.768964,
          17.334
        ]
      },
      {
        "name": "τ2长蛇座",
        "position": [
          9.533036,
          -1.184664,
          158.7302
        ]
      },
      {
        "name": "θ长蛇座",
        "position": [
          9.239405,
          2.31428,
          34.7947
        ]
      },
      {
        "name": "ζ长蛇座",
        "position": [
          8.92323,
          5.945563,
          51.2558
        ]
      },
      {
        "name": "ε长蛇座",
        "position": [
          8.779587,
          6.418809,
          39.6354
        ]
      },
      {
        "name": "δ长蛇座",
        "position": [
          8.627602,
          5.703782,
          49.1642
        ]
      },
      {
        "name": "柳宿二",
        "position": [
          8.645955,
          3.341435,
          114.2857
        ]
      },
      {
        "name": "η长蛇座",
        "position": [
          8.72041,
          3.398662,
          179.8561
        ]
      },
      {
        "name": "ρ长蛇座",
        "position": [
          8.807214,
          5.837812,
          108.5776
        ]
      }
    ],
    "connRel": [
      [
        1301,
        1302
      ],
      [
        1302,
        1303
      ],
      [
        1303,
        1304
      ],
      [
        1304,
        1305
      ],
      [
        1305,
        1306
      ],
      [
        1306,
        1307
      ],
      [
        1307,
        1308
      ],
      [
        1308,
        1309
      ],
      [
        1309,
        1310
      ],
      [
        1310,
        1311
      ],
      [
        1311,
        1312
      ],
      [
        1312,
        1313
      ],
      [
        1313,
        1314
      ],
      [
        1314,
        1315
      ],
      [
        1315,
        1316
      ],
      [
        1316,
        1317
      ],
      [
        1312,
        1317
      ]
    ],
    "iconSize": { width: 12000, height: 12000 },
    "iconPosition": 'λ长蛇座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "8时10分~15时03分",
    "decRange": "-35.7°~6.9°",
    "symbol": "九头蛇",
    "lucida": "长蛇座α(星宿一)",
    "area": "1303km²",
    "containedStars": "76",
    "bestObs": "2-6月"
  },
  {
    "name": "大熊座",
    "latinName": "Ursa Major",
    "id": 14,
    "starsOrigin": [
      {
        "name": "中台二@1",
        "position": [
          10.37216,
          41.49952,
          70.6215
        ]
      },
      {
        "name": "θ大熊座",
        "position": [
          9.547715,
          51.6773,
          13.4789
        ]
      },
      {
        "name": "φ大熊座",
        "position": [
          9.868433,
          54.06433,
          156.0062
        ]
      },
      {
        "name": "υ大熊座",
        "position": [
          9.849867,
          59.03873,
          35.6379
        ]
      },
      {
        "name": "内阶一",
        "position": [
          8.504431,
          60.71817,
          54.9149
        ]
      },
      {
        "name": "23大熊座",
        "position": [
          9.525453,
          63.06186,
          23.8152
        ]
      },
      {
        "name": "北斗一",
        "position": [
          11.06215,
          61.75103,
          37.679
        ]
      },
      {
        "name": "北斗二",
        "position": [
          11.03068,
          56.38243,
          24.4499
        ]
      },
      {
        "name": "北斗三",
        "position": [
          11.89717,
          53.69476,
          25.5037
        ]
      },
      {
        "name": "χ大熊座",
        "position": [
          11.76752,
          47.77941,
          56.3063
        ]
      },
      {
        "name": "ψ大熊座",
        "position": [
          11.16106,
          44.49849,
          44.3066
        ]
      },
      {
        "name": "中台二@2",
        "position": [
          9.060427,
          47.15652,
          109.8901
        ]
      },
      {
        "name": "中台一@1",
        "position": [
          10.28495,
          42.91436,
          42.1585
        ]
      },
      {
        "name": "中台一@2",
        "position": [
          8.986828,
          48.04182,
          14.5096
        ]
      },
      {
        "name": "北斗四",
        "position": [
          12.25709,
          57.03262,
          24.6853
        ]
      },
      {
        "name": "开阳",
        "position": [
          13.39875,
          54.92536,
          26.3089
        ]
      },
      {
        "name": "北斗七",
        "position": [
          13.792354,
          49.313265,
          31.8674
        ]
      }
    ],
    "connRel": [
      [
        1417,
        1416
      ],
      [
        1416,
        1415
      ],
      [
        1415,
        1407
      ],
      [
        1407,
        1406
      ],
      [
        1406,
        1405
      ],
      [
        1405,
        1404
      ],
      [
        1404,
        1403
      ],
      [
        1403,
        1408
      ],
      [
        1408,
        1409
      ],
      [
        1409,
        1415
      ],
      [
        1407,
        1408
      ],
      [
        1409,
        1410
      ],
      [
        1410,
        1411
      ],
      [
        1411,
        1413
      ],
      [
        1411,
        1401
      ],
      [
        1403,
        1402
      ],
      [
        1402,
        1414
      ],
      [
        1402,
        1412
      ]
    ],
    "iconSize": { width: 9400, height: 10000 },
    "iconPosition": '北斗二',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "8时08分~14时29分",
    "decRange": "28°~73°",
    "symbol": "一只巨熊",
    "lucida": "大熊座ε(玉衡/北斗五)",
    "area": "1280km²",
    "containedStars": "93",
    "bestObs": "2-5月"
  },
  {
    "name": "鲸鱼座",
    "latinName": "Cetus",
    "id": 15,
    "starsOrigin": [
      {
        "name": "τ鲸鱼座",
        "position": [
          1.734479,
          -15.93748,
          3.6502
        ]
      },
      {
        "name": "天仓四",
        "position": [
          1.857676,
          -10.335038,
          72.0461
        ]
      },
      {
        "name": "刍蒿增二",
        "position": [
          2.322442,
          -2.977643,
          91.659
        ]
      },
      {
        "name": "δ鲸鱼座",
        "position": [
          2.658044,
          0.328511,
          199.2032
        ]
      },
      {
        "name": "天囷八",
        "position": [
          2.721678,
          3.235818,
          24.4081
        ]
      },
      {
        "name": "天囷一@1",
        "position": [
          2.99525,
          8.907365,
          176.6784
        ]
      },
      {
        "name": "天囷一@2",
        "position": [
          3.037992,
          4.089734,
          76.3942
        ]
      },
      {
        "name": "μ鲸鱼座",
        "position": [
          2.749039,
          10.114146,
          25.7732
        ]
      },
      {
        "name": "ξ2鲸鱼座",
        "position": [
          2.469317,
          8.460054,
          59.2066
        ]
      },
      {
        "name": "υ鲸鱼座",
        "position": [
          2.597909,
          5.593246,
          104.2753
        ]
      },
      {
        "name": "θ鲸鱼座",
        "position": [
          1.40039,
          -8.183257,
          34.8918
        ]
      },
      {
        "name": "天仓二",
        "position": [
          1.143164,
          -10.182264,
          37.9939
        ]
      },
      {
        "name": "天仓一",
        "position": [
          0.323799,
          -8.823921,
          84.1751
        ]
      },
      {
        "name": "土司空",
        "position": [
          0.72649,
          -17.986605,
          29.5334
        ]
      }
    ],
    "connRel": [
      [
        1512,
        1513
      ],
      [
        1513,
        1514
      ],
      [
        1514,
        1512
      ],
      [
        1512,
        1511
      ],
      [
        1511,
        1502
      ],
      [
        1502,
        1501
      ],
      [
        1502,
        1503
      ],
      [
        1503,
        1504
      ],
      [
        1504,
        1505
      ],
      [
        1505,
        1507
      ],
      [
        1507,
        1506
      ],
      [
        1506,
        1508
      ],
      [
        1508,
        1509
      ],
      [
        1509,
        1510
      ],
      [
        1510,
        1505
      ]
    ],
    "iconSize": { width: 5000, height: 12000 },
    "iconPosition": '天仓四',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "0时26分~3时23分",
    "decRange": "-24.9°~-10.5°",
    "symbol": "鲸鱼怪",
    "lucida": "鲸鱼座β(土司空)",
    "area": "1231km²",
    "containedStars": "88",
    "bestObs": "10-12月"
  },
  {
    "name": "武仙座",
    "latinName": "Hercules",
    "id": 16,
    "starsOrigin": [
      {
        "name": "θ武仙座",
        "position": [
          17.93755,
          37.250539,
          230.9469
        ]
      },
      {
        "name": "ρ武仙座",
        "position": [
          17.394708,
          37.145946,
          120.6273
        ]
      },
      {
        "name": "π武仙座",
        "position": [
          17.250788,
          36.809162,
          115.4734
        ]
      },
      {
        "name": "η武仙座",
        "position": [
          16.714933,
          38.922254,
          33.3111
        ]
      },
      {
        "name": "ζ武仙座",
        "position": [
          16.688113,
          31.602726,
          10.7158
        ]
      },
      {
        "name": "ε武仙座",
        "position": [
          17.004827,
          30.926405,
          47.5285
        ]
      },
      {
        "name": "天市左垣二",
        "position": [
          17.512308,
          26.110645,
          113.2503
        ]
      },
      {
        "name": "天市左垣一",
        "position": [
          17.250531,
          24.839204,
          23.0362
        ]
      },
      {
        "name": "σ武仙座",
        "position": [
          16.568384,
          42.437041,
          96.5251
        ]
      },
      {
        "name": "τ武仙座",
        "position": [
          16.329011,
          46.313366,
          94.2507
        ]
      },
      {
        "name": "φ武仙座",
        "position": [
          16.146162,
          44.934906,
          62.5391
        ]
      },
      {
        "name": "υ武仙座",
        "position": [
          16.046634,
          46.036705,
          113.8952
        ]
      },
      {
        "name": "天市右垣一",
        "position": [
          16.503668,
          21.489613,
          42.6621
        ]
      },
      {
        "name": "γ武仙座",
        "position": [
          16.365338,
          19.15313,
          59.0667
        ]
      }
    ],
    "connRel": [
      [
        1614,
        1613
      ],
      [
        1613,
        1605
      ],
      [
        1605,
        1604
      ],
      [
        1604,
        1609
      ],
      [
        1609,
        1610
      ],
      [
        1610,
        1611
      ],
      [
        1611,
        1612
      ],
      [
        1608,
        1607
      ],
      [
        1607,
        1606
      ],
      [
        1606,
        1603
      ],
      [
        1603,
        1601
      ],
      [
        1605,
        1606
      ],
      [
        1604,
        1603
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'ε武仙座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "15时48分~18时57分",
    "decRange": "3.8°~51.3°",
    "symbol": "海格力斯",
    "lucida": "武仙座β(河中/天市右垣一)",
    "area": "1225km²",
    "containedStars": "106",
    "bestObs": "6-7月"
  },
  {
    "name": "波江座",
    "latinName": "Eridanus",
    "id": 17,
    "starsOrigin": [
      {
        "name": "水委一",
        "position": [
          1.628556,
          -57.236757,
          42.7533
        ]
      },
      {
        "name": "χ波江座",
        "position": [
          1.932564,
          -51.608896,
          17.8508
        ]
      },
      {
        "name": "φ波江座",
        "position": [
          2.275154,
          -51.512165,
          47.1254
        ]
      },
      {
        "name": "κ波江座",
        "position": [
          2.449755,
          -47.70384,
          155.7632
        ]
      },
      {
        "name": "ι波江座",
        "position": [
          2.677781,
          -39.855375,
          46.1894
        ]
      },
      {
        "name": "天苑六@1",
        "position": [
          2.971023,
          -40.304672,
          49.4315
        ]
      },
      {
        "name": "HR1008",
        "position": [
          3.331944,
          -43.069784,
          6.0434
        ]
      },
      {
        "name": "HR1106",
        "position": [
          3.618244,
          -40.274545,
          70.7714
        ]
      },
      {
        "name": "HR1195",
        "position": [
          3.824237,
          -36.20025,
          64.3501
        ]
      },
      {
        "name": "υ4波江座",
        "position": [
          4.298237,
          -33.798348,
          54.5554
        ]
      },
      {
        "name": "43波江座",
        "position": [
          4.400613,
          -34.016846,
          90.8265
        ]
      },
      {
        "name": "天园九",
        "position": [
          4.592512,
          -30.562341,
          65.5738
        ]
      },
      {
        "name": "τ6波江座",
        "position": [
          3.780804,
          -23.249723,
          17.6274
        ]
      },
      {
        "name": "τ5波江座",
        "position": [
          3.563132,
          -21.632883,
          89.9281
        ]
      },
      {
        "name": "τ4波江座",
        "position": [
          3.325278,
          -21.757864,
          93.3707
        ]
      },
      {
        "name": "τ3波江座",
        "position": [
          3.039863,
          -23.624472,
          27.1739
        ]
      },
      {
        "name": "天苑九",
        "position": [
          2.850645,
          -21.004019,
          57.3066
        ]
      },
      {
        "name": "天苑六@2",
        "position": [
          2.940458,
          -8.898144,
          41.8585
        ]
      },
      {
        "name": "天苑五",
        "position": [
          3.263896,
          -8.81973,
          33.6474
        ]
      },
      {
        "name": "ε波江座",
        "position": [
          3.548848,
          -9.458262,
          3.2161
        ]
      },
      {
        "name": "天苑三",
        "position": [
          3.720806,
          -9.763395,
          9.0408
        ]
      },
      {
        "name": "ν波江座",
        "position": [
          4.605317,
          -3.352459,
          207.0393
        ]
      },
      {
        "name": "ω波江座",
        "position": [
          4.881575,
          -5.452695,
          72.0461
        ]
      },
      {
        "name": "玉井三",
        "position": [
          5.130829,
          -5.086446,
          27.3973
        ]
      },
      {
        "name": "λ波江座",
        "position": [
          5.15244,
          -8.754081,
          248.7562
        ]
      },
      {
        "name": "九斿增四",
        "position": [
          4.63634,
          -14.30402,
          33.6814
        ]
      }
    ],
    "connRel": [
      [
        1701,
        1702
      ],
      [
        1702,
        1703
      ],
      [
        1703,
        1704
      ],
      [
        1704,
        1705
      ],
      [
        1705,
        1706
      ],
      [
        1706,
        1707
      ],
      [
        1707,
        1708
      ],
      [
        1708,
        1709
      ],
      [
        1709,
        1710
      ],
      [
        1710,
        1711
      ],
      [
        1711,
        1712
      ],
      [
        1712,
        1713
      ],
      [
        1713,
        1714
      ],
      [
        1714,
        1715
      ],
      [
        1715,
        1716
      ],
      [
        1716,
        1717
      ],
      [
        1717,
        1718
      ],
      [
        1718,
        1719
      ],
      [
        1719,
        1720
      ],
      [
        1720,
        1721
      ],
      [
        1721,
        1722
      ],
      [
        1722,
        1723
      ],
      [
        1723,
        1724
      ],
      [
        1724,
        1725
      ],
      [
        1725,
        1726
      ]
    ],
    "iconSize": { width: 10000, height: 15000 },
    "iconPosition": 'τ6波江座',
    "labelPositionIdx": 1,
    // "color": "blue",
    "raRange": "1时25分~5时11分",
    "decRange": "-0.4°~-57.9°",
    "symbol": "河流",
    "lucida": "波江座α(水委一)",
    "area": "1168km²",
    "containedStars": "87",
    "bestObs": "11-1月"
  },
  {
    "name": "飞马座",
    "latinName": "Pegasus",
    "id": 18,
    "starsOrigin": [
      {
        "name": "危宿三",
        "position": [
          21.736433,
          9.875011,
          211.4165
        ]
      },
      {
        "name": "危宿二",
        "position": [
          22.169996,
          6.197865,
          28.2965
        ]
      },
      {
        "name": "雷电一",
        "position": [
          22.691033,
          10.831364,
          62.6566
        ]
      },
      {
        "name": "ξ飞马座",
        "position": [
          22.778216,
          12.172888,
          16.2973
        ]
      },
      {
        "name": "室宿一",
        "position": [
          23.079348,
          15.205264,
          40.8831
        ]
      },
      {
        "name": "壁宿一",
        "position": [
          0.220598,
          15.183596,
          120.048
        ]
      },
      {
        "name": "壁宿二",
        "position": [
          0.139791,
          29.090432,
          29.7442
        ]
      },
      {
        "name": "室宿二@2",
        "position": [
          23.062901,
          28.082789,
          60.0962
        ]
      },
      {
        "name": "离宫二",
        "position": [
          22.833385,
          24.601579,
          32.5309
        ]
      },
      {
        "name": "λ飞马座",
        "position": [
          22.775521,
          23.565654,
          111.9821
        ]
      },
      {
        "name": "ι飞马座",
        "position": [
          22.116847,
          25.345112,
          11.7261
        ]
      },
      {
        "name": "κ飞马座",
        "position": [
          21.744092,
          25.645036,
          34.2231
        ]
      },
      {
        "name": "离宫四",
        "position": [
          22.716704,
          30.221245,
          65.703
        ]
      },
      {
        "name": "π2飞马座",
        "position": [
          22.166457,
          33.178224,
          80.6452
        ]
      }
    ],
    "connRel": [
      [
        1801,
        1802
      ],
      [
        1802,
        1803
      ],
      [
        1803,
        1804
      ],
      [
        1804,
        1805
      ],
      [
        1805,
        1806
      ],
      [
        1806,
        1807
      ],
      [
        1807,
        1808
      ],
      [
        1808,
        1809
      ],
      [
        1809,
        1810
      ],
      [
        1810,
        1811
      ],
      [
        1811,
        1812
      ],
      [
        1808,
        1805
      ],
      [
        1808,
        1813
      ],
      [
        1813,
        1814
      ]
    ],
    "iconSize": { width: 10000, height: 10000 },
    "iconPosition": '室宿一',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "21时12分~0时14分",
    "decRange": "2.4°~36.6°",
    "symbol": "神马",
    "lucida": "飞马座ε(危宿三)",
    "area": "1121km²",
    "containedStars": "88",
    "bestObs": "9-10月"
  },
  {
    "name": "天龙座",
    "latinName": "Draco",
    "id": 19,
    "starsOrigin": [
      {
        "name": "紫徽右垣三",
        "position": [
          11.516667,
          69.331076,
          102.145
        ]
      },
      {
        "name": "κ天龙座",
        "position": [
          12.558058,
          69.788238,
          150.3759
        ]
      },
      {
        "name": "右枢",
        "position": [
          14.073165,
          64.37585,
          92.9368
        ]
      },
      {
        "name": "紫薇左垣一",
        "position": [
          15.415494,
          58.966065,
          31.027
        ]
      },
      {
        "name": "θ天龙座",
        "position": [
          16.031532,
          58.565251,
          21.0349
        ]
      },
      {
        "name": "η天龙座",
        "position": [
          16.40,
          61.514213,
          28.2326
        ]
      },
      {
        "name": "紫徽左垣四",
        "position": [
          17.15,
          65.714667,
          100.7049
        ]
      },
      {
        "name": "χ天龙座",
        "position": [
          18.35,
          72.73333,
          8.0574
        ]
      },
      {
        "name": "天厨三",
        "position": [
          19.80,
          70.26667,
          45.3721
        ]
      },
      {
        "name": "天厨一",
        "position": [
          19.21667,
          67.66667,
          29.8686
        ]
      },
      {
        "name": "天罡一",
        "position": [
          17.90,
          56.86667,
          34.5066
        ]
      },
      {
        "name": "天棓二",
        "position": [
          17.537767,
          55.172958,
          30.4878
        ]
      },
      {
        "name": "天罡三",
        "position": [
          17.507213,
          52.301387,
          116.5501
        ]
      },
      {
        "name": "天棓四",
        "position": [
          17.943437,
          51.488895,
          47.3037
        ]
      }
    ],
    "connRel": [
      [
        1901,
        1902
      ],
      [
        1902,
        1903
      ],
      [
        1903,
        1904
      ],
      [
        1904,
        1905
      ],
      [
        1905,
        1906
      ],
      [
        1906,
        1907
      ],
      [
        1907,
        1908
      ],
      [
        1908,
        1909
      ],
      [
        1909,
        1910
      ],
      [
        1910,
        1911
      ],
      [
        1911,
        1912
      ],
      [
        1912,
        1913
      ],
      [
        1913,
        1914
      ],
      [
        1914,
        1911
      ]
    ],
    "iconSize": { width: 8000, height: 8000 },
    "iconPosition": 'η天龙座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "9时23分~20时55分",
    "decRange": "47.5°~86.2°",
    "symbol": "龙",
    "lucida": "天龙座γ(天棓四)",
    "area": "1083km²",
    "containedStars": "76",
    "bestObs": "4-8月"
  },
  {
    "name": "半人马座",
    "latinName": "Centaurus",
    "id": 20,
    "starsOrigin": [
      {
        "name": "λ半人马座",
        "position": [
          11.596363,
          -63.019841,
          128.7001
        ]
      },
      {
        "name": "HR4460",
        "position": [
          11.579355,
          -54.264091,
          130.719
        ]
      },
      {
        "name": "δ半人马座",
        "position": [
          12.13931,
          -50.722425,
          127.2265
        ]
      },
      {
        "name": "γ半人马座",
        "position": [
          12.691971,
          -48.959888,
          39.9042
        ]
      },
      {
        "name": "ζ半人马座",
        "position": [
          13.925667,
          -47.288375,
          117.096
        ]
      },
      {
        "name": "υ1半人马座",
        "position": [
          13.977987,
          -44.803584,
          131.0616
        ]
      },
      {
        "name": "μ半人马座",
        "position": [
          13.826943,
          -42.473732,
          155.0388
        ]
      },
      {
        "name": "η半人马座",
        "position": [
          14.591786,
          -42.157824,
          93.7207
        ]
      },
      {
        "name": "k半人马座",
        "position": [
          14.986025,
          -42.104194,
          117.5088
        ]
      },
      {
        "name": "ε半人马座",
        "position": [
          13.664796,
          -53.466394,
          131.0616
        ]
      },
      {
        "name": "马腹一",
        "position": [
          14.063729,
          -60.373039,
          120.1923
        ]
      },
      {
        "name": "南门二",
        "position": [
          14.660765,
          -60.833976,
          1.3248
        ]
      },
      {
        "name": "ν半人马座",
        "position": [
          13.825078,
          -41.687709,
          133.8688
        ]
      },
      {
        "name": "库楼三",
        "position": [
          14.111395,
          -36.369954,
          18.0343
        ]
      },
      {
        "name": "HR5089",
        "position": [
          13.517405,
          -39.407307,
          277.7778
        ]
      },
      {
        "name": "σ半人马座",
        "position": [
          12.467331,
          -50.230635,
          126.2626
        ]
      },
      {
        "name": "ι半人马座",
        "position": [
          13.343296,
          -36.712295,
          18.0213
        ]
      }
    ],
    "connRel": [
      [
        2001,
        2002
      ],
      [
        2002,
        2003
      ],
      [
        2003,
        2004
      ],
      [
        2004,
        2005
      ],
      [
        2005,
        2006
      ],
      [
        2006,
        2007
      ],
      [
        2007,
        2008
      ],
      [
        2008,
        2009
      ],
      [
        2005,
        2010
      ],
      [
        2010,
        2011
      ],
      [
        2011,
        2012
      ],
      [
        2007,
        2013
      ],
      [
        2013,
        2015
      ],
      [
        2015,
        2017
      ],
      [
        2013,
        2014
      ]
    ],
    "iconSize": { width: 10000, height: 9000 },
    "iconPosition": 'ζ半人马座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "11时05分~15时03分",
    "decRange": "-29.9°~-64.7°",
    "symbol": "半人马",
    "lucida": "半人马座α(南门二)",
    "area": "1060km²",
    "containedStars": "69",
    "bestObs": "4-6月"
  },
  {
    "name": "蛇夫座",
    "latinName": "Ophiuchus",
    "id": 21,
    "starsOrigin": [
      {
        "name": "51蛇夫座",
        "position": [
          17.523598,
          -23.962643,
          124.3781
        ]
      },
      {
        "name": "天市左垣十一",
        "position": [
          17.172968,
          -15.72491,
          27.0929
        ]
      },
      {
        "name": "ζ蛇夫座",
        "position": [
          16.619316,
          -10.56709,
          112.2334
        ]
      },
      {
        "name": "天市右垣十",
        "position": [
          16.305358,
          -4.692511,
          32.6371
        ]
      },
      {
        "name": "κ蛇夫座",
        "position": [
          16.961139,
          9.375033,
          28.0426
        ]
      },
      {
        "name": "候",
        "position": [
          17.582241,
          12.560035,
          14.8965
        ]
      },
      {
        "name": "宗正一",
        "position": [
          17.724543,
          4.567303,
          25.0941
        ]
      }
    ],
    "connRel": [
      [
        2101,
        2102
      ],
      [
        2102,
        2103
      ],
      [
        2103,
        2104
      ],
      [
        2104,
        2105
      ],
      [
        2105,
        2106
      ],
      [
        2106,
        2107
      ],
      [
        2107,
        2102
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'ζ蛇夫座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "16时00分~18时57分",
    "decRange": "-30°~14.5°",
    "symbol": "捕蛇人",
    "lucida": "蛇夫座α(候)",
    "area": "948km²",
    "containedStars": "62",
    "bestObs": "6-7月"
  },
  {
    "name": "牧夫座",
    "latinName": "Bootes",
    "id": 22,
    "starsOrigin": [
      {
        "name": "υ牧夫座",
        "position": [
          13.824623,
          15.797905,
          80.7754
        ]
      },
      {
        "name": "右摄提一",
        "position": [
          13.911411,
          18.397717,
          11.396
        ]
      },
      {
        "name": "大角",
        "position": [
          14.26103,
          19.18241,
          11.2575
        ]
      },
      {
        "name": "ρ牧夫座",
        "position": [
          14.5305,
          30.371437,
          49.0918
        ]
      },
      {
        "name": "招摇",
        "position": [
          14.534636,
          38.308253,
          26.6099
        ]
      },
      {
        "name": "七公增五",
        "position": [
          15.032436,
          40.390566,
          69.0608
        ]
      },
      {
        "name": "δ牧夫座",
        "position": [
          15.258376,
          33.314833,
          37.3413
        ]
      },
      {
        "name": "ε牧夫座",
        "position": [
          14.749784,
          27.074222,
          62.1118
        ]
      },
      {
        "name": "ζ牧夫座",
        "position": [
          14.68582,
          13.7283,
          53.8793
        ]
      },
      {
        "name": "υ牧夫座",
        "position": [
          13.824623,
          15.797905,
          80.7754
        ]
      }
    ],
    "connRel": [
      [
        2201,
        2202
      ],
      [
        2202,
        2203
      ],
      [
        2203,
        2204
      ],
      [
        2204,
        2205
      ],
      [
        2205,
        2206
      ],
      [
        2206,
        2207
      ],
      [
        2207,
        2208
      ],
      [
        2208,
        2203
      ],
      [
        2203,
        2209
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'ε牧夫座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "13时36分~15时49分",
    "decRange": "7.4°~55.0°",
    "symbol": "牧马人",
    "lucida": "牧夫座α(大角星)",
    "area": "907km²",
    "containedStars": "62",
    "bestObs": "5-6月"
  },
  {
    "name": "天鹅座",
    "latinName": "Cygnus",
    "id": 23,
    "starsOrigin": [
      {
        "name": "天津四",
        "position": [
          20.690532,
          45.280338,
          432.9004
        ]
      },
      {
        "name": "天津一",
        "position": [
          20.370473,
          40.256679,
          561.7978
        ]
      },
      {
        "name": "δ天鹅座",
        "position": [
          19.749574,
          45.13081,
          50.5817
        ]
      },
      {
        "name": "θ天鹅座",
        "position": [
          19.607372,
          50.221103,
          18.3352
        ]
      },
      {
        "name": "ι2天鹅座",
        "position": [
          19.495098,
          51.729779,
          37.2024
        ]
      },
      {
        "name": "κ天鹅座",
        "position": [
          19.28504,
          53.368459,
          38.0662
        ]
      },
      {
        "name": "天津九",
        "position": [
          20.770178,
          33.970256,
          22.2916
        ]
      },
      {
        "name": "ζ天鹅座",
        "position": [
          21.215607,
          30.226916,
          43.8789
        ]
      },
      {
        "name": "η天鹅座",
        "position": [
          19.938438,
          35.083424,
          41.3736
        ]
      },
      {
        "name": "辇道增七",
        "position": [
          19.512023,
          27.959681,
          133.1558
        ]
      }
    ],
    "connRel": [
      [
        2301,
        2302
      ],
      [
        2302,
        2303
      ],
      [
        2303,
        2304
      ],
      [
        2304,
        2305
      ],
      [
        2305,
        2306
      ],
      [
        2302,
        2307
      ],
      [
        2307,
        2308
      ],
      [
        2302,
        2309
      ],
      [
        2309,
        2310
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": '天津一',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "19时07分~22时03分",
    "decRange": "27.4°~61.4°",
    "symbol": "天鹅",
    "lucida": "天鹅座α(天津四)",
    "area": "804km²",
    "containedStars": "84",
    "bestObs": "8-9月"
  },
  {
    "name": "鹿豹座",
    "latinName": "Camelopardalis",
    "id": 24,
    "starsOrigin": [
      {
        "name": "HR1686",
        "position": [
          5.376036,
          79.231149,
          20.8855
        ]
      },
      {
        "name": "α鹿豹座",
        "position": [
          4.900836,
          66.342678,
          100000
        ]
      },
      {
        "name": "γ鹿豹座",
        "position": [
          3.839302,
          71.332266,
          110.011
        ]
      },
      {
        "name": "HR1035",
        "position": [
          3.484482,
          59.94033,
          595.2381
        ]
      },
      {
        "name": "HR1204",
        "position": [
          3.957067,
          63.072264,
          110.6195
        ]
      }
    ],
    "connRel": [
      [
        2401,
        2402
      ],
      [
        2402,
        2403
      ],
      [
        2403,
        2404
      ],
      [
        2404,
        2405
      ],
      [
        2405,
        2402
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'γ鹿豹座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "3时15分~14时27分",
    "decRange": "52.3°~86.2°",
    "symbol": "长颈鹿",
    "lucida": "鹿豹座β(八谷增十四)",
    "area": "757km²",
    "containedStars": "36",
    "bestObs": "12-5月"
  },
  {
    "name": "仙女座",
    "latinName": "Andromeda",
    "id": 25,
    "starsOrigin": [
      {
        "name": "壁宿二",
        "position": [
          0.139791,
          29.090432,
          29.7442
        ]
      },
      {
        "name": "δ仙女座",
        "position": [
          0.655462,
          30.861024,
          32.352
        ]
      },
      {
        "name": "奎宿九",
        "position": [
          1.162194,
          35.620558,
          60.5327
        ]
      },
      {
        "name": "天大将军一",
        "position": [
          2.064984,
          42.329725,
          120.4819
        ]
      },
      {
        "name": "μ仙女座",
        "position": [
          0.945885,
          38.499345,
          39.7772
        ]
      },
      {
        "name": "ν仙女座@1",
        "position": [
          0.830234,
          41.078911,
          189.3939
        ]
      }
    ],
    "connRel": [
      [
        2501,
        2502
      ],
      [
        2502,
        2503
      ],
      [
        2503,
        2504
      ],
      [
        2503,
        2505
      ],
      [
        2505,
        2506
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": '奎宿九',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "22时57分~2时39分",
    "decRange": "21.7°~53.58°",
    "symbol": "女神安德洛墨达",
    "lucida": "仙女座β(奎宿九)",
    "area": "722km²",
    "containedStars": "65",
    "bestObs": "10-11月"
  },
  {
    "name": "船尾座",
    "latinName": "Puppis",
    "id": 26,
    "starsOrigin": [
      {
        "name": "ρ船尾座",
        "position": [
          8.125737,
          -24.304324,
          19.4818
        ]
      },
      {
        "name": "弧矢增十七",
        "position": [
          7.821571,
          -24.859786,
          367.6471
        ]
      },
      {
        "name": "π船尾座",
        "position": [
          7.285711,
          -37.09747,
          247.5248
        ]
      },
      {
        "name": "ν船尾座",
        "position": [
          6.629353,
          -43.195934,
          113.8952
        ]
      },
      {
        "name": "τ船尾座",
        "position": [
          6.832266,
          -50.61456,
          55.8036
        ]
      },
      {
        "name": "σ船尾座",
        "position": [
          7.487179,
          -43.301432,
          59.3824
        ]
      },
      {
        "name": "弧矢增二十二",
        "position": [
          8.059737,
          -40.003148,
          332.2259
        ]
      },
      {
        "name": "老人星",
        "position": [
          6.399195,
          -52.69566,
          94.7867
        ]
      },
      {
        "name": "天社一",
        "position": [
          8.158876,
          -47.336588,
          342.4658
        ]
      }
    ],
    "connRel": [
      [
        2601,
        2602
      ],
      [
        2602,
        2603
      ],
      [
        2603,
        2604
      ],
      [
        2604,
        2605
      ],
      [
        2605,
        2606
      ],
      [
        2606,
        2607
      ],
      [
        2607,
        2601
      ],
      [
        2607,
        2609
      ],
      [
        2604,
        2608
      ]
    ],
    "iconSize": { width: 6000, height: 7000 },
    "iconPosition": 'σ船尾座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "6时02分~8时26分",
    "decRange": "-11.0°~-51.2°",
    "symbol": "船尾甲板",
    "lucida": "船尾座ζ(弧矢增二十二)",
    "area": "673km²",
    "containedStars": "76",
    "bestObs": "1-2月"
  },
  {
    "name": "御夫座",
    "latinName": "Auriga",
    "id": 27,
    "starsOrigin": [
      {
        "name": "五车五",
        "position": [
          5.438198,
          28.60745,
          41.0509
        ]
      },
      {
        "name": "五车一",
        "position": [
          4.949894,
          33.16609,
          151.2859
        ]
      },
      {
        "name": "柱二",
        "position": [
          5.041301,
          41.075837,
          240.9639
        ]
      },
      {
        "name": "五车二",
        "position": [
          5.27815,
          45.997991,
          13.1234
        ]
      },
      {
        "name": "五车三",
        "position": [
          5.992149,
          44.947433,
          24.8694
        ]
      },
      {
        "name": "θ御夫座",
        "position": [
          5.995351,
          37.212585,
          50.7614
        ]
      }
    ],
    "connRel": [
      [
        2701,
        2702
      ],
      [
        2702,
        2703
      ],
      [
        2703,
        2704
      ],
      [
        2704,
        2705
      ],
      [
        2705,
        2706
      ],
      [
        2706,
        2701
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": '五车五',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "4时37分~7时30分",
    "decRange": "28.6°~56.2°",
    "symbol": "战车御者",
    "lucida": "御夫座α(五车二)",
    "area": "657km²",
    "containedStars": "65",
    "bestObs": "12-2月"
  },
  {
    "name": "天鹰座",
    "latinName": "Aquila",
    "id": 28,
    "starsOrigin": [
      {
        "name": "吴越增一@1",
        "position": [
          19.090169,
          13.863478,
          25.4582
        ]
      },
      {
        "name": "吴越增一@2",
        "position": [
          18.993711,
          15.068298,
          47.5059
        ]
      },
      {
        "name": "δ天鹰座",
        "position": [
          19.424972,
          3.114775,
          15.5255
        ]
      },
      {
        "name": "λ天鹰座",
        "position": [
          19.10415,
          -4.882554,
          37.9219
        ]
      },
      {
        "name": "河鼓二",
        "position": [
          19.846388,
          8.868322,
          5.1295
        ]
      },
      {
        "name": "虚宿一@1",
        "position": [
          19.921887,
          6.406763,
          13.6986
        ]
      },
      {
        "name": "河鼓三",
        "position": [
          19.770994,
          10.613261,
          121.0654
        ]
      },
      {
        "name": "河鼓三",
        "position": [
          19.770994,
          10.613261,
          121.0654
        ]
      },
      {
        "name": "η天鹰座",
        "position": [
          19.874547,
          1.005661,
          423.7288
        ]
      },
      {
        "name": "θ天鹰座",
        "position": [
          20.188413,
          -0.821461,
          87.7963
        ]
      }
    ],
    "connRel": [
      [
        2801,
        2802
      ],
      [
        2802,
        2803
      ],
      [
        2803,
        2809
      ],
      [
        2809,
        2810
      ],
      [
        2803,
        2804
      ],
      [
        2803,
        2805
      ],
      [
        2805,
        2806
      ],
      [
        2805,
        2807
      ]
    ],
    "iconSize": { width: 6000, height: 7000 },
    "iconPosition": 'δ天鹰座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "18时41分~20时39分",
    "decRange": "-11.9°~18.7°",
    "symbol": "雕",
    "lucida": "天鹰座α(牛郎星、河鼓二)",
    "area": "652km²",
    "containedStars": "65",
    "bestObs": "7-8月"
  },
  {
    "name": "巨蛇座",
    "latinName": "Serpens",
    "id": 29,
    "starsOrigin": [
      {
        "name": "天市左垣七",
        "position": [
          18.936995,
          4.203595,
          47.4158
        ]
      },
      {
        "name": "η巨蛇座",
        "position": [
          18.355167,
          -2.898825,
          18.5426
        ]
      },
      {
        "name": "ν蛇夫座@1",
        "position": [
          17.983775,
          -9.773632,
          46.2107
        ]
      },
      {
        "name": "ξ巨蛇座",
        "position": [
          17.626445,
          -15.398557,
          32.2789
        ]
      },
      {
        "name": "ν巨蛇座",
        "position": [
          17.347128,
          -12.846875,
          62.3053
        ]
      },
      {
        "name": "天市左垣十一",
        "position": [
          17.172968,
          -15.72491,
          27.0929
        ]
      },
      {
        "name": "天市右垣九",
        "position": [
          16.239094,
          -3.694323,
          52.4659
        ]
      },
      {
        "name": "μ巨蛇座（头）",
        "position": [
          15.827002,
          -3.430208,
          52.0021
        ]
      },
      {
        "name": "ε巨蛇座（头）",
        "position": [
          15.846935,
          4.47773,
          21.5983
        ]
      },
      {
        "name": "天市右垣七",
        "position": [
          15.737798,
          6.425627,
          22.6757
        ]
      },
      {
        "name": "δ巨蛇座（头）",
        "position": [
          15.580041,
          10.538867,
          69.9301
        ]
      },
      {
        "name": "β巨蛇座（头）",
        "position": [
          15.769793,
          15.421826,
          47.5511
        ]
      },
      {
        "name": "κ巨蛇座（头）",
        "position": [
          15.812327,
          18.141564,
          117.096
        ]
      },
      {
        "name": "ρ巨蛇座（头）",
        "position": [
          15.85442,
          20.977919,
          114.9425
        ]
      },
      {
        "name": "ι巨蛇座（头）",
        "position": [
          15.692516,
          19.670401,
          58.2751
        ]
      },
      {
        "name": "γ巨蛇座（头）",
        "position": [
          15.940882,
          15.661617,
          11.2537
        ]
      }
    ],
    "connRel": [
      [
        2901,
        2902
      ],
      [
        2902,
        2903
      ],
      [
        2903,
        2904
      ],
      [
        2904,
        2905
      ],
      [
        2905,
        2906
      ],
      [
        2906,
        2907
      ],
      [
        2907,
        2908
      ],
      [
        2908,
        2909
      ],
      [
        2909,
        2910
      ],
      [
        2910,
        2911
      ],
      [
        2911,
        2912
      ],
      [
        2912,
        2913
      ],
      [
        2913,
        2914
      ],
      [
        2913,
        2915
      ],
      [
        2913,
        2916
      ]
    ],
    "iconSize": { width: 8000, height: 8000 },
    "iconPosition": '天市左垣十一',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "15时10分~18时57分",
    "decRange": "-16.1°~25.5°",
    "symbol": "蛇",
    "lucida": "巨蛇座α(蜀/天市右垣七)",
    "area": "637km²",
    "containedStars": "57",
    "bestObs": "6-8月"
  },
  {
    "name": "英仙座",
    "latinName": "Perseus",
    "id": 30,
    "starsOrigin": [
      {
        "name": "大陵六",
        "position": [
          3.08627,
          38.840274,
          94.3396
        ]
      },
      {
        "name": "大陵五",
        "position": [
          3.136148,
          40.955648,
          27.571
        ]
      },
      {
        "name": "卷舌增七",
        "position": [
          3.738648,
          32.288248,
          343.6426
        ]
      },
      {
        "name": "ζ英仙座",
        "position": [
          3.9022,
          31.883635,
          230.4147
        ]
      },
      {
        "name": "ε英仙座",
        "position": [
          3.96423,
          40.010215,
          195.6947
        ]
      },
      {
        "name": "δ英仙座",
        "position": [
          3.715416,
          47.787551,
          158.2278
        ]
      },
      {
        "name": "天船三@1",
        "position": [
          3.405378,
          49.86118,
          155.2795
        ]
      },
      {
        "name": "γ英仙座",
        "position": [
          3.079942,
          53.50644,
          74.5712
        ]
      },
      {
        "name": "室宿二@1",
        "position": [
          3.98275,
          35.791033,
          381.6794
        ]
      },
      {
        "name": "天船一",
        "position": [
          2.844945,
          55.895496,
          269.5418
        ]
      }
    ],
    "connRel": [
      [
        3001,
        3002
      ],
      [
        3002,
        3007
      ],
      [
        3007,
        3006
      ],
      [
        3006,
        3005
      ],
      [
        3005,
        3009
      ],
      [
        3009,
        3004
      ],
      [
        3004,
        3003
      ],
      [
        3007,
        3008
      ],
      [
        3008,
        3010
      ]
    ],
    "iconSize": { width: 6000, height: 7000 },
    "iconPosition": '天船三@1',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "1时29分~4时52分",
    "decRange": "30.7°~59°",
    "symbol": "珀尔修斯",
    "lucida": "英仙座α(天船三)",
    "area": "615km²",
    "containedStars": "65",
    "bestObs": "10-12月"
  },
  {
    "name": "仙后座",
    "latinName": "Cassiopeia",
    "id": 31,
    "starsOrigin": [
      {
        "name": "王良一",
        "position": [
          0.152887,
          59.14978,
          16.7842
        ]
      },
      {
        "name": "王良四",
        "position": [
          0.675116,
          56.537331,
          69.979
        ]
      },
      {
        "name": "策",
        "position": [
          0.945143,
          60.71674,
          168.3502
        ]
      },
      {
        "name": "阁道三",
        "position": [
          1.430216,
          60.235283,
          30.4785
        ]
      },
      {
        "name": "阁道二",
        "position": [
          1.906584,
          63.670101,
          126.2626
        ]
      }
    ],
    "connRel": [
      [
        3101,
        3102
      ],
      [
        3102,
        3103
      ],
      [
        3103,
        3104
      ],
      [
        3104,
        3105
      ]
    ],
    "iconSize": { width: 2600, height: 2600 },
    "iconPosition": '策',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "22时57分~3时41分",
    "decRange": "46.7°~77.7°",
    "symbol": "王后卡西奥佩娅",
    "lucida": "仙后座α(王良四)",
    "area": "598km²",
    "containedStars": "53",
    "bestObs": "10-12月"
  },
  {
    "name": "猎户座",
    "latinName": "Orion",
    "id": 32,
    "starsOrigin": [
      {
        "name": "π6猎户座",
        "position": [
          4.975806,
          1.714016,
          289.8551
        ]
      },
      {
        "name": "π5猎户座",
        "position": [
          4.904193,
          2.440672,
          411.5226
        ]
      },
      {
        "name": "π4猎户座",
        "position": [
          4.853434,
          5.605104,
          322.5806
        ]
      },
      {
        "name": "π3猎户座",
        "position": [
          4.830669,
          6.961276,
          8.0684
        ]
      },
      {
        "name": "参宿五",
        "position": [
          5.418851,
          6.349702,
          77.3994
        ]
      },
      {
        "name": "φ2猎户座",
        "position": [
          5.615108,
          9.290673,
          36.0231
        ]
      },
      {
        "name": "参宿四",
        "position": [
          5.919529,
          7.407063,
          152.6718
        ]
      },
      {
        "name": "μ猎户座",
        "position": [
          6.039722,
          9.647276,
          47.5059
        ]
      },
      {
        "name": "ξ猎户座",
        "position": [
          6.198999,
          14.208765,
          186.2197
        ]
      },
      {
        "name": "64猎户座",
        "position": [
          6.057602,
          19.690561,
          220.2643
        ]
      },
      {
        "name": "π2猎户座",
        "position": [
          4.843534,
          8.900176,
          68.8231
        ]
      },
      {
        "name": "π1猎户座",
        "position": [
          4.914924,
          10.150833,
          35.6633
        ]
      },
      {
        "name": "参宿一",
        "position": [
          5.679313,
          -1.942572,
          225.7336
        ]
      },
      {
        "name": "参宿二",
        "position": [
          5.603559,
          -1.20192,
          606.0606
        ]
      },
      {
        "name": "参宿三",
        "position": [
          5.533445,
          -0.299092,
          212.3142
        ]
      },
      {
        "name": "参宿七",
        "position": [
          5.242298,
          -8.20164,
          264.5503
        ]
      },
      {
        "name": "参宿六",
        "position": [
          5.795941,
          -9.669605,
          198.4127
        ]
      },
      {
        "name": "ν猎户座",
        "position": [
          6.126201,
          14.768472,
          158.2278
        ]
      },
      {
        "name": "χ1猎户座",
        "position": [
          5.906386,
          20.276174,
          8.6633
        ]
      }
    ],
    "connRel": [
      [
        3201,
        3202
      ],
      [
        3202,
        3203
      ],
      [
        3203,
        3204
      ],
      [
        3204,
        3205
      ],
      [
        3205,
        3215
      ],
      [
        3215,
        3216
      ],
      [
        3216,
        3217
      ],
      [
        3217,
        3213
      ],
      [
        3213,
        3207
      ],
      [
        3207,
        3208
      ],
      [
        3208,
        3209
      ],
      [
        3209,
        3218
      ],
      [
        3218,
        3219
      ],
      [
        3208,
        3218
      ],
      [
        3209,
        3210
      ],
      [
        3204,
        3211
      ],
      [
        3211,
        3212
      ],
      [
        3215,
        3214
      ],
      [
        3214,
        3213
      ],
      [
        3205,
        3206
      ],
      [
        3206,
        3207
      ]
    ],
    "iconSize": { width: 7000, height: 7000 },
    "iconPosition": '参宿五',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "4时43分~6时25分",
    "decRange": "-11.0°~22.9°",
    "symbol": "猎手",
    "lucida": "猎户座β(参宿七)",
    "area": "594km²",
    "containedStars": "81",
    "bestObs": "12-1月"
  },
  {
    "name": "仙王座",
    "latinName": "Cepheus",
    "id": 33,
    "starsOrigin": [
      {
        "name": "θ仙王座",
        "position": [
          20.493015,
          62.994105,
          41.841
        ]
      },
      {
        "name": "η仙王座",
        "position": [
          20.754811,
          61.838782,
          14.2653
        ]
      },
      {
        "name": "天钩五",
        "position": [
          21.30963,
          62.585573,
          15.0376
        ]
      },
      {
        "name": "ζ仙王座",
        "position": [
          22.180908,
          58.201261,
          256.4103
        ]
      },
      {
        "name": "ι仙王座",
        "position": [
          22.82802,
          66.200408,
          35.3482
        ]
      },
      {
        "name": "少卫增八",
        "position": [
          23.65582,
          77.632276,
          14.1024
        ]
      },
      {
        "name": "上卫增一",
        "position": [
          21.477662,
          70.560716,
          210.084
        ]
      }
    ],
    "connRel": [
      [
        3301,
        3302
      ],
      [
        3302,
        3303
      ],
      [
        3303,
        3304
      ],
      [
        3304,
        3305
      ],
      [
        3305,
        3306
      ],
      [
        3306,
        3307
      ],
      [
        3307,
        3303
      ],
      [
        3307,
        3305
      ]
    ],
    "iconSize": { width: 7000, height: 7000 },
    "iconPosition": '上卫增一',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "20时01分~8时53分",
    "decRange": "53.5°~88.7°",
    "symbol": "国王",
    "lucida": "仙王座α(天钩五)",
    "area": "588km²",
    "containedStars": "43",
    "bestObs": "9-10月"
  },
  {
    "name": "天猫座",
    "latinName": "Lynx",
    "id": 34,
    "starsOrigin": [
      {
        "name": "2天猫座",
        "position": [
          6.327052,
          59.010964,
          48.0077
        ]
      },
      {
        "name": "15天猫座",
        "position": [
          6.954612,
          58.422759,
          54.6747
        ]
      },
      {
        "name": "21天猫座",
        "position": [
          7.445237,
          49.211527,
          83.8926
        ]
      },
      {
        "name": "上台增四",
        "position": [
          8.380588,
          43.188131,
          117.2333
        ]
      },
      {
        "name": "HR3579",
        "position": [
          9.010685,
          41.782911,
          16.0694
        ]
      },
      {
        "name": "HR3612",
        "position": [
          9.108825,
          38.452215,
          250.6266
        ]
      },
      {
        "name": "38天猫座",
        "position": [
          9.314069,
          36.802597,
          38.2702
        ]
      },
      {
        "name": "α天猫座",
        "position": [
          9.350925,
          34.392562,
          62.2665
        ]
      }
    ],
    "connRel": [
      [
        3401,
        3402
      ],
      [
        3402,
        3403
      ],
      [
        3403,
        3404
      ],
      [
        3404,
        3405
      ],
      [
        3405,
        3406
      ],
      [
        3406,
        3407
      ],
      [
        3407,
        3408
      ]
    ],
    "iconSize": { width: 6000, height: 8000 },
    "iconPosition": '上台增四',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "6时16分~9时42分",
    "decRange": "32.9°~61.4°",
    "symbol": "神话中的动物Lynx",
    "lucida": "天猫座α(轩辕四)",
    "area": "545km²",
    "containedStars": "42",
    "bestObs": "2-3月"
  },
  {
    "name": "船帆座",
    "latinName": "Vela",
    "id": 35,
    "starsOrigin": [
      {
        "name": "μ船帆座",
        "position": [
          10.779488,
          -49.420255,
          35.9195
        ]
      },
      {
        "name": "HR4167",
        "position": [
          10.621717,
          -48.22562,
          26.8384
        ]
      },
      {
        "name": "HR4023",
        "position": [
          10.245607,
          -42.121942,
          31.0752
        ]
      },
      {
        "name": "ψ船帆座",
        "position": [
          9.511674,
          -40.466769,
          18.8147
        ]
      },
      {
        "name": "天记",
        "position": [
          9.133268,
          -43.432589,
          166.9449
        ]
      },
      {
        "name": "天社一",
        "position": [
          8.158876,
          -47.336588,
          342.4658
        ]
      },
      {
        "name": "δ船帆座",
        "position": [
          8.745059,
          -54.708821,
          24.6975
        ]
      },
      {
        "name": "κ船帆座",
        "position": [
          9.368562,
          -55.010668,
          175.4386
        ]
      },
      {
        "name": "φ船帆座",
        "position": [
          9.947708,
          -54.56779,
          487.8049
        ]
      }
    ],
    "connRel": [
      [
        3501,
        3502
      ],
      [
        3502,
        3503
      ],
      [
        3503,
        3504
      ],
      [
        3504,
        3505
      ],
      [
        3505,
        3506
      ],
      [
        3506,
        3507
      ],
      [
        3507,
        3508
      ],
      [
        3508,
        3509
      ],
      [
        3509,
        3501
      ]
    ],
    "iconSize": { width: 6400, height: 6400 },
    "iconPosition": 'δ船帆座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "8时00分~11时05分",
    "decRange": "-37°~-57°",
    "symbol": "帆",
    "lucida": "船帆座γ(天社一)",
    "area": "500km²",
    "containedStars": "50",
    "bestObs": "2-4月"
  },
  {
    "name": "船底座",
    "latinName": "Carina",
    "id": 36,
    "starsOrigin": [
      {
        "name": "南船二",
        "position": [
          9.220041,
          -69.717208,
          34.6981
        ]
      },
      {
        "name": "ω船底座",
        "position": [
          10.228961,
          -70.037903,
          104.8218
        ]
      },
      {
        "name": "θ船底座",
        "position": [
          10.715949,
          -64.39445,
          139.6648
        ]
      },
      {
        "name": "HR4220",
        "position": [
          10.774889,
          -64.263242,
          145.9854
        ]
      },
      {
        "name": "HR4337",
        "position": [
          11.143165,
          -58.975037,
          100000.0
        ]
      },
      {
        "name": "HR4257",
        "position": [
          10.891559,
          -58.853171,
          29.129
        ]
      },
      {
        "name": "HR4114",
        "position": [
          10.464649,
          -58.739403,
          411.5226
        ]
      },
      {
        "name": "HR4050",
        "position": [
          10.28472,
          -61.332304,
          201.6129
        ]
      },
      {
        "name": "海石二",
        "position": [
          9.284838,
          -59.275229,
          234.7418
        ]
      },
      {
        "name": "海石一",
        "position": [
          8.375236,
          -59.509483,
          185.5288
        ]
      },
      {
        "name": "天社一",
        "position": [
          8.158876,
          -47.336588,
          342.4658
        ]
      },
      {
        "name": "老人星",
        "position": [
          6.399195,
          -52.69566,
          94.7867
        ]
      }
    ],
    "connRel": [
      [
        3601,
        3602
      ],
      [
        3602,
        3603
      ],
      [
        3603,
        3604
      ],
      [
        3604,
        3605
      ],
      [
        3605,
        3606
      ],
      [
        3606,
        3607
      ],
      [
        3607,
        3608
      ],
      [
        3608,
        3609
      ],
      [
        3609,
        3610
      ],
      [
        3610,
        3611
      ],
      [
        3610,
        3612
      ]
    ],
    "iconSize": { width: 7000, height: 7000 },
    "iconPosition": '海石一',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "6时02分~11时20分",
    "decRange": "-50.8°~-75.7°",
    "symbol": "阿格号的龙骨",
    "lucida": "船底座α(老人星)",
    "area": "494km²",
    "containedStars": "52",
    "bestObs": "1-4月"
  },
  {
    "name": "麒麟座",
    "latinName": "Monoceros",
    "id": 37,
    "starsOrigin": [
      {
        "name": "γ麒麟座",
        "position": [
          6.247592,
          -6.274776,
          152.6718
        ]
      },
      {
        "name": "β麒麟座",
        "position": [
          6.480297,
          -7.033062,
          207.4689
        ]
      },
      {
        "name": "δ麒麟座",
        "position": [
          7.197739,
          -0.492764,
          117.7856
        ]
      },
      {
        "name": "ζ麒麟座",
        "position": [
          8.143236,
          -2.983786,
          324.6753
        ]
      },
      {
        "name": "α麒麟座",
        "position": [
          7.687454,
          -9.551131,
          45.3104
        ]
      },
      {
        "name": "ε麒麟座",
        "position": [
          6.396135,
          4.592865,
          37.4953
        ]
      }
    ],
    "connRel": [
      [
        3701,
        3702
      ],
      [
        3702,
        3703
      ],
      [
        3703,
        3704
      ],
      [
        3704,
        3705
      ],
      [
        3703,
        3706
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'δ麒麟座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "5时55分~8时11分",
    "decRange": "-11.0°~-12.8°",
    "symbol": "祥瑞",
    "lucida": "麒麟座β(参宿增二十六)",
    "area": "482km²",
    "containedStars": "32",
    "bestObs": "1-2月"
  },
  {
    "name": "玉夫座",
    "latinName": "Sculptor",
    "id": 38,
    "starsOrigin": [
      {
        "name": "β玉夫座",
        "position": [
          23.549512,
          -37.818268,
          53.3618
        ]
      },
      {
        "name": "γ玉夫座",
        "position": [
          23.313733,
          -32.532027,
          55.8659
        ]
      },
      {
        "name": "δ玉夫座",
        "position": [
          23.815427,
          -28.130268,
          42.1408
        ]
      },
      {
        "name": "α玉夫座",
        "position": [
          0.976766,
          -29.357449,
          238.0952
        ]
      }
    ],
    "connRel": [
      [
        3801,
        3802
      ],
      [
        3802,
        3803
      ],
      [
        3803,
        3804
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'δ玉夫座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "23时06分~1时46分",
    "decRange": "-24.9°~-39.5°",
    "symbol": "雕刻家",
    "lucida": "玉夫座α(近土司空南)",
    "area": "475km²",
    "containedStars": "18",
    "bestObs": "10-11月"
  },
  {
    "name": "凤凰座",
    "latinName": "Phoenix",
    "id": 39,
    "starsOrigin": [
      {
        "name": "κ凤凰座",
        "position": [
          0.436716,
          -43.679829,
          23.8095
        ]
      },
      {
        "name": "γ凤凰座",
        "position": [
          1.472759,
          -43.318234,
          71.6332
        ]
      },
      {
        "name": "β凤凰座",
        "position": [
          1.101407,
          -46.718414,
          100000
        ]
      },
      {
        "name": "ψ凤凰座",
        "position": [
          1.894102,
          -46.302669,
          104.8218
        ]
      },
      {
        "name": "δ凤凰座",
        "position": [
          1.520851,
          -49.072702,
          43.573
        ]
      },
      {
        "name": "ζ凤凰座",
        "position": [
          1.139742,
          -55.24576,
          91.5751
        ]
      },
      {
        "name": "ε凤凰座",
        "position": [
          0.156836,
          -45.747426,
          44.2087
        ]
      },
      {
        "name": "火鸟六",
        "position": [
          0.438056,
          -42.305981,
          25.974
        ]
      }
    ],
    "connRel": [
      [
        3901,
        3902
      ],
      [
        3902,
        3903
      ],
      [
        3903,
        3904
      ],
      [
        3904,
        3905
      ],
      [
        3905,
        3903
      ],
      [
        3903,
        3906
      ],
      [
        3906,
        3901
      ],
      [
        3901,
        3907
      ],
      [
        3901,
        3907
      ],
      [
        3907,
        3908
      ],
      [
        3908,
        3901
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'δ凤凰座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "23时26分~2时25分",
    "decRange": "-39.5°~-57.9°",
    "symbol": "凤凰",
    "lucida": "凤凰座α(火鸟六)",
    "area": "469km²",
    "containedStars": "18",
    "bestObs": "10-11月"
  },
  {
    "name": "猎犬座",
    // "latinName": "Canes Venaticorum",
    "latinName": "Canes Venatici",
    "id": 40,
    "starsOrigin": [
      {
        "name": "常陈一",
        "position": [
          12.933807,
          38.31838,
          35.1989
        ]
      },
      {
        "name": "常陈四",
        "position": [
          12.562411,
          41.35748,
          8.4395
        ]
      }
    ],
    "connRel": [
      [
        4001,
        4002
      ]
    ],
    "iconSize": { width: 2800, height: 2800 },
    "iconPosition": '常陈一',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "12时06分~14时07分",
    "decRange": "27.8°~52.9°",
    "symbol": "狗",
    "lucida": "猎犬座α(常陈一)",
    "area": "465km²",
    "containedStars": "21",
    "bestObs": "4-5月"
  },
  {
    "name": "天炉座",
    "latinName": "Fornax",
    "id": 41,
    "starsOrigin": [
      {
        "name": "β天炉座",
        "position": [
          2.818169,
          -32.405898,
          52.9381
        ]
      },
      {
        "name": "天苑增三",
        "position": [
          3.201249,
          -28.987618,
          14.2369
        ]
      }
    ],
    "connRel": [
      [
        4101,
        4102
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": '天苑增三',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "1时45分~3时50分",
    "decRange": "-2.8°~-39.5°",
    "symbol": "火炉",
    "lucida": "天炉座α(天苑增三）",
    "area": "398km²",
    "containedStars": "27",
    "bestObs": "11-12月"
  },
  {
    "name": "后发座",
    "latinName": "Coma Berenices",
    "id": 42,
    "starsOrigin": [
      {
        "name": "γ后发座",
        "position": [
          12.448966,
          28.268423,
          51.2821
        ]
      },
      {
        "name": "β后发座",
        "position": [
          13.197904,
          27.878183,
          9.1291
        ]
      },
      {
        "name": "太微左垣五",
        "position": [
          13.166469,
          17.529431,
          17.8253
        ]
      }
    ],
    "connRel": [
      [
        4201,
        4202
      ],
      [
        4202,
        4203
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'β后发座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "11时58分~13时34分",
    "decRange": "13.3°~33.3°",
    "symbol": "埃及皇后伯伦尼斯二世的头发",
    "lucida": "后发座β(周鼎一)",
    "area": "386km²",
    "containedStars": "44",
    "bestObs": "4-5月"
  },
  {
    "name": "大犬座",
    "latinName": "Canis Major",
    "id": 43,
    "starsOrigin": [
      {
        "name": "军市一",
        "position": [
          6.378329,
          -17.955918,
          151.0574
        ]
      },
      {
        "name": "ν2大犬座",
        "position": [
          6.611399,
          -19.255879,
          19.7511
        ]
      },
      {
        "name": "ο1大犬座",
        "position": [
          6.902209,
          -24.184211,
          100000
        ]
      },
      {
        "name": "σ大犬座",
        "position": [
          7.028652,
          -27.93483,
          343.6426
        ]
      },
      {
        "name": "弧矢一",
        "position": [
          7.139857,
          -26.3932,
          492.6108
        ]
      },
      {
        "name": "ω大犬座",
        "position": [
          7.246849,
          -26.772667,
          279.3296
        ]
      },
      {
        "name": "弧矢二",
        "position": [
          7.401584,
          -29.303104,
          609.7561
        ]
      },
      {
        "name": "ξ2大犬座",
        "position": [
          6.584274,
          -22.964793,
          135.318
        ]
      },
      {
        "name": "天狼",
        "position": [
          6.752481,
          -16.716116,
          2.6371
        ]
      },
      {
        "name": "ι大犬座",
        "position": [
          6.935618,
          -17.054242,
          769.2308
        ]
      },
      {
        "name": "天狼增四",
        "position": [
          7.062637,
          -15.633286,
          135.5014
        ]
      },
      {
        "name": "θ大犬座",
        "position": [
          6.903167,
          -12.038628,
          79.9361
        ]
      },
      {
        "name": "弧矢七",
        "position": [
          6.977097,
          -28.972084,
          124.2236
        ]
      },
      {
        "name": "κ大犬座",
        "position": [
          6.830683,
          -32.508478,
          202.0202
        ]
      },
      {
        "name": "孙增一",
        "position": [
          6.338553,
          -30.063367,
          111.1111
        ]
      }
    ],
    "connRel": [
      [
        4301,
        4302
      ],
      [
        4302,
        4303
      ],
      [
        4303,
        4304
      ],
      [
        4304,
        4305
      ],
      [
        4305,
        4306
      ],
      [
        4306,
        4307
      ],
      [
        4304,
        4313
      ],
      [
        4313,
        4314
      ],
      [
        4313,
        4315
      ],
      [
        4302,
        4308
      ],
      [
        4302,
        4309
      ],
      [
        4309,
        4310
      ],
      [
        4310,
        4311
      ],
      [
        4311,
        4312
      ],
      [
        4312,
        4310
      ],
      [
        4302,
        4309
      ],
      [
        4309,
        4305
      ],
      [
        4305,
        4304
      ]
    ],
    "iconSize": { width: 3400, height: 3400 },
    "iconPosition": 'ο1大犬座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "6时12分~7时28分",
    "decRange": "-11.0°~-33.1°",
    "symbol": "大犬",
    "lucida": "大犬座α(天狼星)",
    "area": "380km²",
    "containedStars": "32",
    "bestObs": "1-2月"
  },
  {
    "name": "孔雀座",
    "latinName": "Pavo",
    "id": 44,
    "starsOrigin": [
      {
        "name": "η孔雀座",
        "position": [
          17.762221,
          -64.723871,
          107.9914
        ]
      },
      {
        "name": "π孔雀座",
        "position": [
          18.143,
          -63.668553,
          39.8565
        ]
      },
      {
        "name": "ξ孔雀座",
        "position": [
          18.387117,
          -61.493901,
          143.6782
        ]
      },
      {
        "name": "λ孔雀座",
        "position": [
          18.870288,
          -62.187593,
          438.5965
        ]
      },
      {
        "name": "κ孔雀座",
        "position": [
          18.949177,
          -67.233495,
          153.3742
        ]
      },
      {
        "name": "ζ孔雀座",
        "position": [
          18.71726,
          -71.428113,
          66.9792
        ]
      },
      {
        "name": "ε孔雀座",
        "position": [
          20.009845,
          -72.910504,
          32.2165
        ]
      },
      {
        "name": "δ孔雀座",
        "position": [
          20.145157,
          -66.182068,
          6.1084
        ]
      },
      {
        "name": "β孔雀座",
        "position": [
          20.749314,
          -66.203212,
          41.425
        ]
      },
      {
        "name": "γ孔雀座",
        "position": [
          21.440705,
          -65.366198,
          9.2618
        ]
      },
      {
        "name": "孔雀座",
        "position": [
          20.427459,
          -56.73509,
          54.8246
        ]
      }
    ],
    "connRel": [
      [
        4401,
        4402
      ],
      [
        4402,
        4403
      ],
      [
        4403,
        4404
      ],
      [
        4404,
        4405
      ],
      [
        4405,
        4406
      ],
      [
        4406,
        4407
      ],
      [
        4407,
        4408
      ],
      [
        4408,
        4409
      ],
      [
        4409,
        4410
      ],
      [
        4410,
        4411
      ],
      [
        4411,
        4408
      ],
      [
        4408,
        4405
      ],
      [
        4404,
        4402
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'δ孔雀座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "17时36分~21时32分",
    "decRange": "-56.4°~-74.2°",
    "symbol": "孔雀",
    "lucida": "孔雀座α(孔雀十一)",
    "area": "378km²",
    "containedStars": "24",
    "bestObs": "7-9月"
  },
  {
    "name": "天鹤座",
    "latinName": "Grus",
    "id": 45,
    "starsOrigin": [
      {
        "name": "ζ天鹤座",
        "position": [
          23.014677,
          -52.754137,
          33.3778
        ]
      },
      {
        "name": "β天鹤座",
        "position": [
          22.711115,
          -46.884577,
          54.2594
        ]
      },
      {
        "name": "ι天鹤座",
        "position": [
          23.17264,
          -45.246711,
          56.1798
        ]
      },
      {
        "name": "θ天鹤座",
        "position": [
          23.11465,
          -43.520358,
          40.4367
        ]
      },
      {
        "name": "δ1天鹤座",
        "position": [
          22.487825,
          -43.495565,
          94.8767
        ]
      },
      {
        "name": "鹤一",
        "position": [
          22.137209,
          -46.960975,
          30.9693
        ]
      },
      {
        "name": "λ天鹤座",
        "position": [
          22.101914,
          -39.543353,
          74.239
        ]
      },
      {
        "name": "γ天鹤座",
        "position": [
          21.898808,
          -37.364852,
          64.7249
        ]
      },
      {
        "name": "ε天鹤座",
        "position": [
          22.809239,
          -51.316864,
          39.5257
        ]
      }
    ],
    "connRel": [
      [
        4501,
        4502
      ],
      [
        4502,
        4503
      ],
      [
        4503,
        4504
      ],
      [
        4504,
        4505
      ],
      [
        4505,
        4506
      ],
      [
        4506,
        4507
      ],
      [
        4507,
        4508
      ],
      [
        4502,
        4506
      ],
      [
        4502,
        4509
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'β天鹤座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "21时27分~23时27分",
    "decRange": "-36.8°~-56.4°",
    "symbol": "鹤",
    "lucida": "天鹤座α(鹤一)",
    "area": "366km²",
    "containedStars": "18",
    "bestObs": "8-10月"
  },
  {
    "name": "豺狼座",
    "latinName": "Lupus",
    "id": 46,
    "starsOrigin": [
      {
        "name": "ρ豺狼座",
        "position": [
          14.631454,
          -49.425828,
          96.8992
        ]
      },
      {
        "name": "ζ豺狼座",
        "position": [
          15.20476,
          -52.099247,
          35.9712
        ]
      },
      {
        "name": "α豺狼座",
        "position": [
          14.698823,
          -47.3882,
          142.4501
        ]
      },
      {
        "name": "β豺狼座",
        "position": [
          14.975537,
          -43.13396,
          117.3709
        ]
      },
      {
        "name": "δ豺狼座",
        "position": [
          15.356201,
          -40.647518,
          271.0027
        ]
      },
      {
        "name": "γ豺狼座",
        "position": [
          15.585681,
          -41.166757,
          129.0323
        ]
      },
      {
        "name": "ω豺狼座",
        "position": [
          15.634232,
          -42.567348,
          67.0241
        ]
      },
      {
        "name": "η豺狼座",
        "position": [
          16.002036,
          -38.396706,
          135.5014
        ]
      },
      {
        "name": "θ豺狼座",
        "position": [
          16.109874,
          -36.802288,
          127.0648
        ]
      },
      {
        "name": "χ豺狼座",
        "position": [
          15.849316,
          -33.627165,
          59.8444
        ]
      },
      {
        "name": "ν豺狼座",
        "position": [
          15.412504,
          -39.710268,
          124.6883
        ]
      },
      {
        "name": "φ1豺狼座",
        "position": [
          15.36344,
          -36.261376,
          84.317
        ]
      }
    ],
    "connRel": [
      [
        4608,
        4609
      ],
      [
        4609,
        4610
      ],
      [
        4610,
        4608
      ],
      [
        4608,
        4606
      ],
      [
        4606,
        4607
      ],
      [
        4607,
        4602
      ],
      [
        4602,
        4601
      ],
      [
        4602,
        4603
      ],
      [
        4603,
        4604
      ],
      [
        4604,
        4605
      ],
      [
        4605,
        4606
      ],
      [
        4605,
        4612
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'γ豺狼座',
    "labelPositionIdx": 1,
    "raRange": "14时03分~16时00分",
    "decRange": "-29.9°~-55.7°",
    "symbol": "狼",
    "lucida": "豺狼座α(骑官十)",
    "area": "334km²",
    "containedStars": "41",
    "bestObs": "5-6月"
  },
  {
    "name": "六分仪座",
    "latinName": "Sextans",
    "id": 47,
    "starsOrigin": [
      {
        "name": "α六分仪座",
        "position": [
          10.1323,
          -0.371637,
          86.881
        ]
      },
      {
        "name": "β六分仪座",
        "position": [
          10.504855,
          -0.637026,
          124.0695
        ]
      },
      {
        "name": "γ六分仪座",
        "position": [
          9.875121,
          -8.10503,
          85.1064
        ]
      }
    ],
    "connRel": [
      [
        4701,
        4703
      ],
      [
        4703,
        4702
      ]
    ],
    "iconSize": { width: 4400, height: 4400 },
    "iconPosition": 'γ六分仪座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "9时41分~10时51分",
    "decRange": "-0.4°~6.9°",
    "symbol": "六分仪",
    "lucida": "六分仪座α(天相二)",
    "area": "314km²",
    "containedStars": "28",
    "bestObs": "2-4月"
  },
  {
    "name": "杜鹃座",
    "latinName": "Tucana",
    "id": 48,
    "starsOrigin": [
      {
        "name": "ζ杜鹃座",
        "position": [
          0.334142,
          -64.874791,
          8.5866
        ]
      },
      {
        "name": "γ杜鹃座",
        "position": [
          23.290498,
          -58.235734,
          23.0574
        ]
      },
      {
        "name": "α杜鹃座",
        "position": [
          22.308371,
          -60.259587,
          61.237
        ]
      },
      {
        "name": "β1杜鹃座",
        "position": [
          0.525725,
          -62.958218,
          41.4079
        ]
      }
    ],
    "connRel": [
      [
        4802,
        4801
      ],
      [
        4803,
        4802
      ],
      [
        4802,
        4804
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'γ杜鹃座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "22时08分~1时24分",
    "decRange": "-56°~-76°",
    "symbol": "大嘴鸟",
    "lucida": "杜鹃座α(鸟喙一)",
    "area": "295km²",
    "containedStars": "17",
    "bestObs": "9-11月"
  },
  {
    "name": "印第安座",
    "latinName": "Indus",
    "id": 49,
    "starsOrigin": [
      {
        "name": "α印第安座",
        "position": [
          20.626116,
          -47.291502,
          30.1477
        ]
      },
      {
        "name": "θ印第安座",
        "position": [
          21.331096,
          -53.449427,
          30.2847
        ]
      },
      {
        "name": "δ印第安座",
        "position": [
          21.965293,
          -54.992575,
          57.6701
        ]
      },
      {
        "name": "β印第安座",
        "position": [
          20.913498,
          -58.454155,
          187.6173
        ]
      }
    ],
    "connRel": [
      [
        4901,
        4902
      ],
      [
        4902,
        4903
      ],
      [
        4904,
        4902
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'θ印第安座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "20时28分~23时28分",
    "decRange": "-45°~-74.2°",
    "symbol": "印第安人",
    "lucida": "印第安座α(波斯二)",
    "area": "294km²",
    "containedStars": "16",
    "bestObs": "8-10月"
  },
  {
    "name": "南极座",
    "latinName": "Octans",
    "id": 50,
    "starsOrigin": [
      {
        "name": "θ南极座",
        "position": [
          0.026616,
          -77.065724,
          66.5779
        ]
      },
      {
        "name": "β南极座",
        "position": [
          22.767692,
          -81.381615,
          45.7666
        ]
      },
      {
        "name": "δ南极座",
        "position": [
          14.448801,
          -83.667884,
          91.659
        ]
      },
      {
        "name": "ν南极座@1",
        "position": [
          21.691253,
          -77.390046,
          21.1999
        ]
      }
    ],
    "connRel": [
      [
        5001,
        5002
      ],
      [
        5002,
        5003
      ],
      [
        5003,
        5004
      ],
      [
        5004,
        5002
      ]
    ],
    "iconSize": { width: 6000, height: 6000 },
    "iconPosition": 'β南极座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "0时~24时",
    "decRange": "-74.2°~-90°",
    "symbol": "八分仪",
    "lucida": "南极座ν(蛇尾三)",
    "area": "291km²",
    "containedStars": "27",
    "bestObs": "10-11月"
  },
  {
    "name": "天兔座",
    "latinName": "Lepus",
    "id": 51,
    "starsOrigin": [
      {
        "name": "ν天兔座",
        "position": [
          5.333062,
          -12.315585,
          102.2495
        ]
      },
      {
        "name": "λ天兔座",
        "position": [
          5.326257,
          -13.176788,
          261.0966
        ]
      },
      {
        "name": "μ天兔座",
        "position": [
          5.215528,
          -16.205468,
          57.0125
        ]
      },
      {
        "name": "厕一",
        "position": [
          5.545504,
          -17.822289,
          680.2721
        ]
      },
      {
        "name": "厕二",
        "position": [
          5.470756,
          -20.759441,
          49.1642
        ]
      },
      {
        "name": "δ天兔座",
        "position": [
          5.855357,
          -20.879089,
          34.8675
        ]
      },
      {
        "name": "17天兔座",
        "position": [
          6.083091,
          -16.484435,
          278.5515
        ]
      },
      {
        "name": "19天兔座",
        "position": [
          6.128233,
          -19.165866,
          257.0694
        ]
      },
      {
        "name": "HR2166",
        "position": [
          6.115976,
          -21.812299,
          384.6154
        ]
      },
      {
        "name": "γ天兔座",
        "position": [
          5.741057,
          -22.448382,
          8.927
        ]
      },
      {
        "name": "κ天兔座",
        "position": [
          5.220522,
          -12.941291,
          223.2143
        ]
      },
      {
        "name": "ι天兔座",
        "position": [
          5.204973,
          -11.869219,
          71.0732
        ]
      },
      {
        "name": "θ天兔座",
        "position": [
          6.10259,
          -14.935254,
          52.9661
        ]
      },
      {
        "name": "η天兔座",
        "position": [
          5.940082,
          -14.1677,
          14.8787
        ]
      },
      {
        "name": "ζ天兔座",
        "position": [
          5.782595,
          -14.82195,
          21.6076
        ]
      },
      {
        "name": "ε天兔座",
        "position": [
          5.091018,
          -22.371032,
          65.4022
        ]
      }
    ],
    "connRel": [
      [
        5110,5109
      ],
      [
        5109,5108
      ],
      [
        5108,5107
      ],
      [
        5107,5113
      ],
      [
        5113,5114
      ],
      [
        5114,5115
      ],
      [
        5115,5104
      ],
      [
        5104,5103
      ],
      [
        5103,5102
      ],
      [
        5102,5101
      ],
      [
        5103,5111
      ],
      [
        5111,5112
      ],
      [
        5107,5106
      ],
      [
        5106,5104
      ],
      [
        5106,5105
      ],
      [
        5104,5105
      ],
      [
        5105,5116
      ],
      [
        5105,5103
      ]
    ],
    "iconSize": { width: 4400, height: 3000 },
    "iconPosition": '厕一',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "5时19分~6时02分",
    "decRange": "-11°~-27.3°",
    "symbol": "兔",
    "lucida": "天兔座α(厕一)",
    "area": "290km²",
    "containedStars": "27",
    "bestObs": "12-2月"
  },
  {
    "name": "天琴座",
    "latinName": "Lyra",
    "id": 52,
    "starsOrigin": [
      {
        "name": "织女星",
        "position": [
          18.61564,
          38.783692,
          7.6787
        ]
      },
      {
        "name": "ζ1天琴座",
        "position": [
          18.746209,
          37.605115,
          47.8698
        ]
      },
      {
        "name": "δ2天琴座",
        "position": [
          18.908412,
          36.898613,
          225.7336
        ]
      },
      {
        "name": "渐台三",
        "position": [
          18.982395,
          32.689557,
          190.1141
        ]
      },
      {
        "name": "渐台二",
        "position": [
          18.834665,
          33.362667,
          294.9853
        ]
      }
    ],
    "connRel": [
      [
        5201,
        5202
      ],
      [
        5202,
        5203
      ],
      [
        5203,
        5204
      ],
      [
        5204,
        5205
      ],
      [
        5205,
        5202
      ]
    ],
    "iconSize": { width: 2600, height: 2600 },
    "iconPosition": 'ζ1天琴座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "18时14分~19时28分",
    "decRange": "25.5°~47.5°",
    "symbol": "竖琴",
    "lucida": "天琴座α(织女一)",
    "area": "286km²",
    "containedStars": "25",
    "bestObs": "7-8月"
  },
  {
    "name": "巨爵座",
    "latinName": "Crater",
    "id": 53,
    "starsOrigin": [
      {
        "name": "ζ巨爵座",
        "position": [
          11.746049,
          -18.350674,
          108.2251
        ]
      },
      {
        "name": "η巨爵座",
        "position": [
          11.933599,
          -17.150829,
          77.101
        ]
      },
      {
        "name": "θ巨爵座",
        "position": [
          11.611365,
          -9.802247,
          85.9845
        ]
      },
      {
        "name": "ε巨爵座",
        "position": [
          11.410164,
          -10.859323,
          115.3403
        ]
      },
      {
        "name": "δ巨爵座",
        "position": [
          11.322347,
          -14.778541,
          56.9476
        ]
      },
      {
        "name": "翼宿一",
        "position": [
          10.996244,
          -18.298783,
          48.8043
        ]
      },
      {
        "name": "β巨爵座",
        "position": [
          11.194302,
          -22.825847,
          104.2753
        ]
      },
      {
        "name": "γ巨爵座",
        "position": [
          11.414702,
          -17.68401,
          25.2398
        ]
      }
    ],
    "connRel": [
      [
        5301,
        5302
      ],
      [
        5302,
        5303
      ],
      [
        5303,
        5304
      ],
      [
        5304,
        5305
      ],
      [
        5305,
        5306
      ],
      [
        5306,
        5307
      ],
      [
        5307,
        5308
      ],
      [
        5308,
        5301
      ],
      [
        5305,
        5308
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'γ巨爵座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "10时51分~11时56分",
    "decRange": "-6.7°~-25.2°",
    "symbol": "杯子",
    "lucida": "巨爵座δ(翼宿七)",
    "area": "282km²",
    "containedStars": "12",
    "bestObs": "3-5月"
  },
  {
    "name": "天鸽座",
    "latinName": "Columba",
    "id": 54,
    "starsOrigin": [
      {
        "name": "ε天鸽座",
        "position": [
          5.520209,
          -35.470519,
          80.7103
        ]
      },
      {
        "name": "丈人一",
        "position": [
          5.660817,
          -34.074108,
          80.1282
        ]
      },
      {
        "name": "子二",
        "position": [
          5.849329,
          -35.768309,
          26.7308
        ]
      },
      {
        "name": "γ天鸽座",
        "position": [
          5.958947,
          -35.28328,
          266.6667
        ]
      },
      {
        "name": "K天鸽座",
        "position": [
          6.275871,
          -35.140519,
          55.9597
        ]
      },
      {
        "name": "δ天鸽座",
        "position": [
          6.368564,
          -33.4364,
          71.736
        ]
      },
      {
        "name": "η天鸽座",
        "position": [
          5.985778,
          -42.815135,
          144.7178
        ]
      }
    ],
    "connRel": [
      [
        5401,
        5402
      ],
      [
        5402,
        5403
      ],
      [
        5403,
        5404
      ],
      [
        5404,
        5405
      ],
      [
        5405,
        5406
      ],
      [
        5403,
        5407
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": '丈人一',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "5时03分~6时39分",
    "decRange": "-27.1°~-43.1°",
    "symbol": "圣鸽",
    "lucida": "天鸽座α(丈人一)",
    "area": "270km²",
    "containedStars": "18",
    "bestObs": "12-2月"
  },
  {
    "name": "狐狸座",
    "latinName": "Vulpecula",
    "id": 55,
    "starsOrigin": [
      {
        "name": "23狐狸座",
        "position": [
          20.262816,
          27.814242,
          103.8422
        ]
      },
      {
        "name": "15狐狸座",
        "position": [
          20.018346,
          27.753573,
          72.4638
        ]
      },
      {
        "name": "13狐狸座",
        "position": [
          19.891026,
          24.079614,
          102.5641
        ]
      },
      {
        "name": "齐增五",
        "position": [
          19.478427,
          24.664905,
          91.1577
        ]
      },
      {
        "name": "1狐狸座",
        "position": [
          19.270289,
          21.390428,
          248.7562
        ]
      }
    ],
    "connRel": [
      [
        5501,
        5502
      ],
      [
        5502,
        5503
      ],
      [
        5503,
        5504
      ],
      [
        5504,
        5505
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": '13狐狸座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "18时57分~21时30分",
    "decRange": "19°~29°",
    "symbol": "狐狸",
    "lucida": "狐狸座α(齐增五)",
    "area": "268km²",
    "containedStars": "33",
    "bestObs": "7-9月"
  },
  {
    "name": "小熊座",
    "latinName": "Ursa Minor",
    "id": 56,
    "starsOrigin": [
      {
        "name": "北极星",
        "position": [
          2.52975,
          89.264109,
          132.626
        ]
      },
      {
        "name": "勾陈二",
        "position": [
          17.536918,
          86.58646,
          52.7704
        ]
      },
      {
        "name": "ε小熊座",
        "position": [
          16.766159,
          82.037262,
          93.1966
        ]
      },
      {
        "name": "ζ小熊座",
        "position": [
          15.734299,
          77.794493,
          113.1222
        ]
      },
      {
        "name": "η小熊座",
        "position": [
          16.291791,
          75.75533,
          29.7354
        ]
      },
      {
        "name": "北极二",
        "position": [
          14.845105,
          74.155505,
          40.1445
        ]
      },
      {
        "name": "北极一",
        "position": [
          15.345483,
          71.834016,
          149.2537
        ]
      }
    ],
    "connRel": [
      [
        5601,
        5602
      ],
      [
        5602,
        5603
      ],
      [
        5603,
        5604
      ],
      [
        5604,
        5605
      ],
      [
        5605,
        5607
      ],
      [
        5607,
        5606
      ],
      [
        5606,
        5604
      ]
    ],
    "iconSize": { width: 3800, height: 3800 },
    "iconPosition": 'ζ小熊座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "0时~24时",
    "decRange": "65°~90°",
    "symbol": "小熊",
    "lucida": "小熊座α(勾陈一)",
    "area": "256km²",
    "containedStars": "23",
    "bestObs": "5-6月"
  },
  {
    "name": "望远镜座",
    "latinName": "Telescopium",
    "id": 57,
    "starsOrigin": [
      {
        "name": "ζ望远镜座",
        "position": [
          18.480505,
          -49.070588,
          38.6997
        ]
      },
      {
        "name": "α望远镜座",
        "position": [
          18.449561,
          -45.968459,
          85.1789
        ]
      }
    ],
    "connRel": [
      [
        5701,
        5702
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": 'ζ望远镜座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "18时09分~20时30分",
    "decRange": "-45.5°~-56.4°",
    "symbol": "望远镜",
    "lucida": "望远镜座α(鳖一)",
    "area": "251km²",
    "containedStars": "13",
    "bestObs": "7-8月"
  },
  {
    "name": "时钟座",
    "latinName": "Horologium",
    "id": 58,
    "starsOrigin": [
      {
        "name": "α时钟座",
        "position": [
          4.233363,
          -42.294368,
          35.2609
        ]
      },
      {
        "name": "ι时钟座",
        "position": [
          2.709265,
          -50.800294,
          17.1674
        ]
      },
      {
        "name": "η时钟座",
        "position": [
          2.623425,
          -52.543086,
          45.5581
        ]
      },
      {
        "name": "ζ时钟座",
        "position": [
          2.677666,
          -54.549911,
          49.0918
        ]
      },
      {
        "name": "μ时钟座",
        "position": [
          3.060239,
          -59.737775,
          43.4028
        ]
      },
      {
        "name": "β时钟座",
        "position": [
          2.979939,
          -64.071284,
          90.3342
        ]
      }
    ],
    "connRel": [
      [
        5801,
        5802
      ],
      [
        5802,
        5803
      ],
      [
        5803,
        5804
      ],
      [
        5804,
        5805
      ],
      [
        5805,
        5806
      ]
    ],
    "iconSize": { width: 8000, height: 8000 },
    "iconPosition": 'η时钟座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "2时12分~4时20分",
    "decRange": "-9.5°~-67.0°",
    "symbol": "时钟",
    "lucida": "时钟座α(天园增六)",
    "area": "249km²",
    "containedStars": "10",
    "bestObs": "11-12月"
  },
  {
    "name": "绘架座",
    "latinName": "Pictor",
    "id": 59,
    "starsOrigin": [
      {
        "name": "α绘架座",
        "position": [
          6.803194,
          -61.941391,
          29.6033
        ]
      },
      {
        "name": "γ绘架座",
        "position": [
          5.830451,
          -56.166663,
          54.2005
        ]
      },
      {
        "name": "β绘架座",
        "position": [
          5.788079,
          -51.066514,
          19.4401
        ]
      }
    ],
    "connRel": [
      [
        5901,
        5902
      ],
      [
        5902,
        5903
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'γ绘架座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "4时32分~6时52分",
    "decRange": "-42.3°~-64.7°",
    "symbol": "画画用的架子",
    "lucida": "绘架座α(金鱼增一)",
    "area": "247km²",
    "containedStars": "15",
    "bestObs": "12-2月"
  },
  {
    "name": "南鱼座",
    "latinName": "Piscis Austrinus",
    "id": 60,
    "starsOrigin": [
      {
        "name": "北落师门",
        "position": [
          22.960838,
          -29.622236,
          7.7036
        ]
      },
      {
        "name": "ε南鱼座",
        "position": [
          22.677594,
          -27.043617,
          149.2537
        ]
      },
      {
        "name": "ι南鱼座",
        "position": [
          21.749113,
          -33.025781,
          62.6174
        ]
      },
      {
        "name": "μ南鱼座",
        "position": [
          22.139722,
          -32.988468,
          41.6493
        ]
      },
      {
        "name": "γ南鱼座",
        "position": [
          22.875427,
          -32.875504,
          66.0502
        ]
      },
      {
        "name": "δ南鱼座",
        "position": [
          22.932472,
          -32.539628,
          47.259
        ]
      },
      {
        "name": "β南鱼座",
        "position": [
          22.52509,
          -32.346073,
          43.7828
        ]
      }
    ],
    "connRel": [
      [
        6001,
        6002
      ],
      [
        6002,
        6003
      ],
      [
        6003,
        6004
      ],
      [
        6004,
        6007
      ],
      [
        6007,
        6005
      ],
      [
        6005,
        6006
      ],
      [
        6006,
        6001
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'β南鱼座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "21时26分~23时07分",
    "decRange": "-24.9~-36.8°",
    "symbol": "南方的鱼",
    "lucida": "南鱼座α(北落师门)",
    "area": "245km²",
    "containedStars": "21",
    "bestObs": "8-10月"
  },
  {
    "name": "水蛇座",
    "latinName": "Hydrus",
    "id": 61,
    "starsOrigin": [
      {
        "name": "水蛇座之首",
        "position": [
          1.979451,
          -61.569859,
          22.0119
        ]
      },
      {
        "name": "δ水蛇座",
        "position": [
          2.362498,
          -68.659418,
          42.8266
        ]
      },
      {
        "name": "ε水蛇座",
        "position": [
          2.659799,
          -68.266946,
          46.5549
        ]
      },
      {
        "name": "γ水蛇座",
        "position": [
          3.787295,
          -74.238962,
          65.6168
        ]
      },
      {
        "name": "β水蛇座",
        "position": [
          0.427916,
          -77.254247,
          7.4588
        ]
      }
    ],
    "connRel": [
      [
        6101,
        6102
      ],
      [
        6102,
        6103
      ],
      [
        6103,
        6104
      ],
      [
        6104,
        6105
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'δ水蛇座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "0时06分~4时33分",
    "decRange": "-57.9°~-82.1°",
    "symbol": "水蛇",
    "lucida": "水蛇座β(蛇尾一)",
    "area": "243km²",
    "containedStars": "19",
    "bestObs": "10-12月"
  },
  {
    "name": "唧筒座",
    "latinName": "Antlia",
    "id": 62,
    "starsOrigin": [
      {
        "name": "ι唧筒座",
        "position": [
          10.945289,
          -37.137765,
          58.2751
        ]
      },
      {
        "name": "α唧筒座",
        "position": [
          10.45253,
          -31.067779,
          112.2334
        ]
      },
      {
        "name": "ε唧筒座",
        "position": [
          9.487423,
          -35.951335,
          217.8649
        ]
      }
    ],
    "connRel": [
      [
        6201,
        6202
      ],
      [
        6202,
        6203
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'α唧筒座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "9时26分~11时05分",
    "decRange": "-24.5°~40.4°",
    "symbol": "气泵",
    "lucida": "唧筒座α(近天纪增二)",
    "area": "239km²",
    "containedStars": "9",
    "bestObs": "2-4月"
  },
  {
    "name": "天坛座",
    "latinName": "Ara",
    "id": 63,
    "starsOrigin": [
      {
        "name": "δ天坛座",
        "position": [
          17.518318,
          -60.683848,
          60.6796
        ]
      },
      {
        "name": "η天坛座",
        "position": [
          16.82976,
          -59.041378,
          91.7431
        ]
      },
      {
        "name": "ζ天坛座",
        "position": [
          16.977006,
          -55.990141,
          149.0313
        ]
      },
      {
        "name": "α天坛座",
        "position": [
          17.530695,
          -49.876145,
          81.9672
        ]
      },
      {
        "name": "θ天坛座",
        "position": [
          18.11052,
          -50.091477,
          249.3766
        ]
      },
      {
        "name": "β天坛座",
        "position": [
          17.421665,
          -55.529884,
          198.0198
        ]
      },
      {
        "name": "γ天坛座",
        "position": [
          17.423239,
          -56.377727,
          341.2969
        ]
      }
    ],
    "connRel": [
      [
        6301,
        6302
      ],
      [
        6302,
        6303
      ],
      [
        6303,
        6304
      ],
      [
        6304,
        6305
      ],
      [
        6305,
        6306
      ],
      [
        6306,
        6307
      ],
      [
        6307,
        6301
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'β天坛座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "16时34分~18时10分",
    "decRange": "-45.5°~67.7°",
    "symbol": "圣坛",
    "lucida": "天坛座β(杵三)",
    "area": "237km²",
    "containedStars": "17",
    "bestObs": "6-7月"
  },
  {
    "name": "小狮座",
    "latinName": "Leo Minor",
    "id": 64,
    "starsOrigin": [
      {
        "name": "10小狮子",
        "position": [
          9.570384,
          36.397558,
          56.7215
        ]
      },
      {
        "name": "21小狮座",
        "position": [
          10.123821,
          35.244693,
          28.2406
        ]
      },
      {
        "name": "势四",
        "position": [
          10.888526,
          34.214871,
          29.0867
        ]
      },
      {
        "name": "β小狮座",
        "position": [
          10.464727,
          36.707212,
          47.1921
        ]
      }
    ],
    "connRel": [
      [
        6401,
        6402
      ],
      [
        6402,
        6403
      ],
      [
        6403,
        6404
      ],
      [
        6404,
        6402
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": '21小狮座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "9时22分~11时06分",
    "decRange": "22.8°~41.4°",
    "symbol": "小狮子",
    "lucida": "小狮座46(势四)",
    "area": "232km²",
    "containedStars": "34",
    "bestObs": "2-4月"
  },
  {
    "name": "罗盘座",
    "latinName": "Pyxis",
    "id": 65,
    "starsOrigin": [
      {
        "name": "γ罗盘座",
        "position": [
          8.842204,
          -27.709844,
          63.5728
        ]
      },
      {
        "name": "α罗盘座",
        "position": [
          8.726539,
          -33.186385,
          269.5418
        ]
      },
      {
        "name": "β罗盘座",
        "position": [
          8.668373,
          -35.308352,
          127.551
        ]
      }
    ],
    "connRel": [
      [
        6501,
        6502
      ],
      [
        6502,
        6503
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'α罗盘座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "8时26分~9时27分",
    "decRange": "-17.4°~-37.3°",
    "symbol": "指南针盘",
    "lucida": "罗盘座α(天狗五)",
    "area": "221km²",
    "containedStars": "10",
    "bestObs": "2-3月"
  },
  {
    "name": "显微镜座",
    "latinName": "Microscopium",
    "id": 66,
    "starsOrigin": [
      {
        "name": "ι显微镜座",
        "position": [
          20.808084,
          -43.988544,
          35.4233
        ]
      },
      {
        "name": "α显微镜座",
        "position": [
          20.8328,
          -33.779722,
          116.0093
        ]
      },
      {
        "name": "γ显微镜座",
        "position": [
          21.021517,
          -32.257767,
          70.2247
        ]
      },
      {
        "name": "ε显微镜座",
        "position": [
          21.298966,
          -32.172539,
          55.8659
        ]
      },
      {
        "name": "θ1显微镜座",
        "position": [
          21.346008,
          -40.809465,
          60.4595
        ]
      }
    ],
    "connRel": [
      [
        6601,
        6602
      ],
      [
        6602,
        6603
      ],
      [
        6603,
        6604
      ],
      [
        6604,
        6605
      ],
      [
        6605,
        6601
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'θ1显微镜座',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "20时27分~21时28分",
    "decRange": "-27.5°~-45.5°",
    "symbol": "显微镜",
    "lucida": "显微镜座γ(璃瑜增一)",
    "area": "210km²",
    "containedStars": "13",
    "bestObs": "8-9月"
  },
  {
    "name": "天燕座",
    "latinName": "Apus",
    "id": 67,
    "starsOrigin": [
      {
        "name": "α天燕座",
        "position": [
          14.797701,
          -79.044751,
          136.9863
        ]
      },
      {
        "name": "γ天燕座",
        "position": [
          16.557609,
          -78.897148,
          47.9157
        ]
      }
    ],
    "connRel": [
      [
        6701,
        6702
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'γ天燕座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "13时49分~18时27分",
    "decRange": "-67.5°~-83.1°",
    "symbol": "天堂鸟(极乐鸟)",
    "lucida": "天燕座α(异雀八)",
    "area": "206km²",
    "containedStars": "12",
    "bestObs": "5-7月"
  },
  {
    "name": "蝎虎座",
    "latinName": "Lacerta",
    "id": 68,
    "starsOrigin": [
      {
        "name": "1蝎虎座",
        "position": [
          22.26616,
          37.748737,
          190.4762
        ]
      },
      {
        "name": "6蝎虎座",
        "position": [
          22.508128,
          43.123376,
          526.3158
        ]
      },
      {
        "name": "5蝎虎座",
        "position": [
          22.492173,
          47.706887,
          505.0505
        ]
      },
      {
        "name": "4蝎虎座",
        "position": [
          22.408609,
          49.476392,
          689.6552
        ]
      },
      {
        "name": "β蝎虎座",
        "position": [
          22.392675,
          52.229046,
          52.1105
        ]
      },
      {
        "name": "α蝎虎座",
        "position": [
          22.521515,
          50.282491,
          31.4564
        ]
      }
    ],
    "connRel": [
      [
        6801,
        6802
      ],
      [
        6802,
        6803
      ],
      [
        6803,
        6804
      ],
      [
        6804,
        6805
      ],
      [
        6805,
        6806
      ],
      [
        6806,
        6804
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": '4蝎虎座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "21时57分~22时58分",
    "decRange": "35.3°~56.2°",
    "symbol": "蜥蜴",
    "lucida": "蝎虎座α(螣蛇一)",
    "area": "201km²",
    "containedStars": "17",
    "bestObs": "8-10月"
  },
  {
    "name": "海豚座",
    "latinName": "Delphinus",
    "id": 69,
    "starsOrigin": [
      {
        "name": "败瓜一",
        "position": [
          20.553547,
          11.303263,
          101.3171
        ]
      },
      {
        "name": "η海豚座",
        "position": [
          20.565845,
          13.027255,
          72.4113
        ]
      },
      {
        "name": "瓠瓜四",
        "position": [
          20.625816,
          14.595087,
          30.931
        ]
      },
      {
        "name": "瓠瓜一",
        "position": [
          20.660635,
          15.912072,
          77.821
        ]
      },
      {
        "name": "γ2海豚座",
        "position": [
          20.77764,
          16.124296,
          38.7297
        ]
      },
      {
        "name": "δ海豚座",
        "position": [
          20.724315,
          15.074581,
          68.4463
        ]
      }
    ],
    "connRel": [
      [
        6901,
        6902
      ],
      [
        6902,
        6903
      ],
      [
        6903,
        6904
      ],
      [
        6904,
        6905
      ],
      [
        6905,
        6906
      ],
      [
        6906,
        6903
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": '瓠瓜四',
    "labelPositionIdx": 1,
    "color": "",
    "raRange": "20时14分~21时08分",
    "decRange": "2.4°~20.9°",
    "symbol": "海豚",
    "lucida": "海豚座β(瓠瓜四)",
    "area": "189km²",
    "containedStars": "19",
    "bestObs": "7-9月"
  },
  {
    "name": "乌鸦座",
    "latinName": "Corvus",
    "id": 70,
    "starsOrigin": [
      {
        "name": "右辖",
        "position": [
          12.140225,
          -24.728875,
          14.9365
        ]
      },
      {
        "name": "轸宿二",
        "position": [
          12.168746,
          -22.619766,
          97.4659
        ]
      },
      {
        "name": "轸宿四",
        "position": [
          12.573121,
          -23.396759,
          44.6628
        ]
      },
      {
        "name": "轸宿三",
        "position": [
          12.497739,
          -16.515432,
          26.6312
        ]
      },
      {
        "name": "轸宿一",
        "position": [
          12.263437,
          -17.541929,
          47.1032
        ]
      }
    ],
    "connRel": [
      [
        7001,
        7002
      ],
      [
        7002,
        7003
      ],
      [
        7003,
        7004
      ],
      [
        7004,
        7002
      ],
      [
        7002,
        7001
      ],
      [
        7002,
        7005
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": '轸宿二',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "11时56分~12时56分",
    "decRange": "-11.9°~-25.2°",
    "symbol": "乌鸦",
    "lucida": "乌鸦座γ(轸宿一)",
    "area": "184km²",
    "containedStars": "10",
    "bestObs": "3-5月"
  },
  {
    "name": "小犬座",
    "latinName": "Canis Minor",
    "id": 71,
    "starsOrigin": [
      {
        "name": "南河二",
        "position": [
          7.452512,
          8.289315,
          49.5786
        ]
      },
      {
        "name": "南河三",
        "position": [
          7.655033,
          5.224993,
          3.5142
        ]
      }
    ],
    "connRel": [
      [
        7101,
        7102
      ]
    ],
    "iconSize": { width: 2600, height: 2600 },
    "iconPosition": '南河二',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "7时06分~8时11分",
    "decRange": "0.4°~13.2°",
    "symbol": "小犬",
    "lucida": "小犬座α(南河三)",
    "area": "183km²",
    "containedStars": "14",
    "bestObs": "1-3月"
  },
  {
    "name": "剑鱼座",
    "latinName": "Dorado",
    "id": 72,
    "starsOrigin": [
      {
        "name": "γ剑鱼座",
        "position": [
          4.267097,
          -51.486648,
          20.4625
        ]
      },
      {
        "name": "α剑鱼座",
        "position": [
          4.566598,
          -55.044975,
          51.7063
        ]
      },
      {
        "name": "β剑鱼座",
        "position": [
          5.560421,
          -62.489825,
          308.642
        ]
      },
      {
        "name": "δ剑鱼座",
        "position": [
          5.746223,
          -65.735526,
          45.8716
        ]
      },
      {
        "name": "HR2102",
        "position": [
          5.901658,
          -63.089627,
          26.2467
        ]
      }
    ],
    "connRel": [
      [
        7201,
        7202
      ],
      [
        7202,
        7203
      ],
      [
        7203,
        7204
      ],
      [
        7204,
        7205
      ],
      [
        7205,
        7203
      ]
    ],
    "iconSize": { width: 5000, height: 5000 },
    "iconPosition": 'β剑鱼座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "3时53分~6时36分",
    "decRange": "-48.7°~-70.6°",
    "symbol": "剑鱼",
    "lucida": "剑鱼座α(金鱼二)",
    "area": "179km²",
    "containedStars": "14",
    "bestObs": "12-1月"
  },
  {
    "name": "北冕座",
    "latinName": "Corona Borealis",
    "id": 73,
    "starsOrigin": [
      {
        "name": "ι北冕座",
        "position": [
          16.024047,
          29.851061,
          95.6023
        ]
      },
      {
        "name": "ε北冕座",
        "position": [
          15.959794,
          26.87788,
          67.8887
        ]
      },
      {
        "name": "δ北冕座",
        "position": [
          15.82657,
          26.068394,
          52.1376
        ]
      },
      {
        "name": "γ北冕座",
        "position": [
          15.712381,
          26.295637,
          44.7828
        ]
      },
      {
        "name": "贯索四",
        "position": [
          15.578128,
          26.714693,
          23.0097
        ]
      },
      {
        "name": "贯索三",
        "position": [
          15.463818,
          29.105703,
          34.2818
        ]
      },
      {
        "name": "θ北冕座",
        "position": [
          15.548829,
          31.359133,
          115.0748
        ]
      }
    ],
    "connRel": [
      [
        7301,
        7302
      ],
      [
        7302,
        7303
      ],
      [
        7303,
        7304
      ],
      [
        7304,
        7305
      ],
      [
        7305,
        7306
      ],
      [
        7306,
        7307
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": '贯索四',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "15时16分~16时25分",
    "decRange": "25.5°~39.7°",
    "symbol": "皇冠",
    "lucida": "北冕座α(贯索四)",
    "area": "179km²",
    "containedStars": "24",
    "bestObs": "5-7月"
  },
  {
    "name": "矩尺座",
    "latinName": "Norma",
    "id": 74,
    "starsOrigin": [
      {
        "name": "κ矩尺座",
        "position": [
          16.224648,
          -54.630467,
          131.2336
        ]
      },
      {
        "name": "γ2矩尺座",
        "position": [
          16.330687,
          -50.155508,
          39.4789
        ]
      },
      {
        "name": "ε矩尺座",
        "position": [
          16.453067,
          -47.554786,
          162.6016
        ]
      },
      {
        "name": "η矩尺座",
        "position": [
          16.053579,
          -49.229695,
          67.2948
        ]
      }
    ],
    "connRel": [
      [
        7401,
        7402
      ],
      [
        7402,
        7403
      ],
      [
        7403,
        7404
      ],
      [
        7404,
        7401
      ],
      [
        7404,
        7402
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": 'γ2矩尺座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "15时03分~16时25分",
    "decRange": "-42.3°~-60.4°",
    "symbol": "T形矩尺",
    "lucida": "矩尺座γ2(近波斯一)",
    "area": "165km²",
    "containedStars": "13",
    "bestObs": "5-7月"
  },
  {
    "name": "山案座",
    "latinName": "Mensa",
    "id": 75,
    "starsOrigin": [
      {
        "name": "α山案座",
        "position": [
          6.170632,
          -74.753045,
          10.1978
        ]
      },
      {
        "name": "γ山案座",
        "position": [
          5.531318,
          -76.340964,
          31.3578
        ]
      },
      {
        "name": "η山案座",
        "position": [
          4.919765,
          -74.936852,
          204.918
        ]
      },
      {
        "name": "β山案座",
        "position": [
          5.045279,
          -71.3143,
          243.309
        ]
      }
    ],
    "connRel": [
      [
        7501,
        7502
      ],
      [
        7502,
        7503
      ],
      [
        7503,
        7504
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": 'γ山案座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "3时12分~7时36分",
    "decRange": "-69.8°~-85.3°",
    "symbol": "桌子",
    "lucida": "山案座α(近附白一)",
    "area": "153km²",
    "containedStars": "16",
    "bestObs": "12-2月"
  },
  {
    "name": "飞鱼座",
    "latinName": "Volans",
    "id": 76,
    "starsOrigin": [
      {
        "name": "α飞鱼座",
        "position": [
          9.040777,
          -66.396076,
          38.2995
        ]
      },
      {
        "name": "β飞鱼座",
        "position": [
          8.428951,
          -66.13689,
          32.9707
        ]
      },
      {
        "name": "ε飞鱼座",
        "position": [
          8.132173,
          -68.617062,
          172.4138
        ]
      },
      {
        "name": "ζ飞鱼座",
        "position": [
          7.697004,
          -72.606098,
          43.2339
        ]
      },
      {
        "name": "γ2飞鱼座",
        "position": [
          7.145788,
          -70.498932,
          42.8633
        ]
      },
      {
        "name": "δ飞鱼座",
        "position": [
          7.280508,
          -67.957152,
          226.2443
        ]
      }
    ],
    "connRel": [
      [
        7601,
        7602
      ],
      [
        7602,
        7603
      ],
      [
        7603,
        7604
      ],
      [
        7604,
        7605
      ],
      [
        7605,
        7606
      ],
      [
        7606,
        7602
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'ε飞鱼座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "6时31分~9时04分",
    "decRange": "-64°~-75°",
    "symbol": "飞鱼",
    "lucida": "飞鱼座β(飞鱼三)",
    "area": "141km²",
    "containedStars": "12",
    "bestObs": "1-3月"
  },
  {
    "name": "苍蝇座",
    "latinName": "Musca",
    "id": 77,
    "starsOrigin": [
      {
        "name": "λ苍蝇座",
        "position": [
          11.760141,
          -66.728763,
          38.9864
        ]
      },
      {
        "name": "ε苍蝇座",
        "position": [
          12.292917,
          -67.960736,
          92.4214
        ]
      },
      {
        "name": "α苍蝇座",
        "position": [
          12.619739,
          -69.135564,
          96.7118
        ]
      },
      {
        "name": "γ苍蝇座",
        "position": [
          12.541134,
          -72.132988,
          99.6016
        ]
      },
      {
        "name": "δ苍蝇座",
        "position": [
          13.037759,
          -71.548855,
          27.8707
        ]
      },
      {
        "name": "β苍蝇座",
        "position": [
          12.771346,
          -68.108119,
          104.712
        ]
      }
    ],
    "connRel": [
      [
        7701,
        7702
      ],
      [
        7702,
        7703
      ],
      [
        7703,
        7704
      ],
      [
        7704,
        7705
      ],
      [
        7705,
        7706
      ],
      [
        7703,
        7706
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'ε苍蝇座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "11时19分~13时51分",
    "decRange": "-64.7°~-75.7°",
    "symbol": "苍蝇",
    "lucida": "苍蝇座α(蜜蜂三)",
    "area": "138km²",
    "containedStars": "13",
    "bestObs": "3-5月"
  },
  {
    "name": "三角座",
    "latinName": "Triangulum",
    "id": 78,
    "starsOrigin": [
      {
        "name": "娄宿增六",
        "position": [
          1.884696,
          29.578829,
          19.4175
        ]
      },
      {
        "name": "γ三角座",
        "position": [
          2.288573,
          33.847194,
          34.4353
        ]
      },
      {
        "name": "β三角座",
        "position": [
          2.159058,
          34.987297,
          38.8954
        ]
      }
    ],
    "connRel": [
      [
        7801,
        7802
      ],
      [
        7802,
        7803
      ],
      [
        7803,
        7801
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": '娄宿增六',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "1时319分~2时50分",
    "decRange": "25°~37°",
    "symbol": "三角形",
    "lucida": "三角座β(天大将军九)",
    "area": "132km²",
    "containedStars": "15",
    "bestObs": "10-12月"
  },
  {
    "name": "蝘蜓座",
    "latinName": "Chamaeleon",
    "id": 79,
    "starsOrigin": [
      {
        "name": "α蝘蜓座",
        "position": [
          8.308703,
          -76.919722,
          19.5618
        ]
      },
      {
        "name": "θ蝘蜓座",
        "position": [
          8.344115,
          -77.484477,
          47.619
        ]
      },
      {
        "name": "δ2蝘蜓座",
        "position": [
          10.763087,
          -80.540188,
          107.5269
        ]
      },
      {
        "name": "β蝘蜓座",
        "position": [
          12.305812,
          -79.31224,
          91.4913
        ]
      },
      {
        "name": "γ蝘蜓座",
        "position": [
          10.591166,
          -78.607786,
          128.041
        ]
      }
    ],
    "connRel": [
      [
        7901,
        7902
      ],
      [
        7902,
        7903
      ],
      [
        7903,
        7904
      ],
      [
        7904,
        7905
      ],
      [
        7905,
        7901
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'δ2蝘蜓座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "7时26分~13时56分",
    "decRange": "-75.3°~-83.1°",
    "symbol": "变色龙",
    "lucida": "蝘蜓座α(小斗增一)",
    "area": "132km²",
    "containedStars": "16",
    "bestObs": "3-5月"
  },
  {
    "name": "南冕座",
    "latinName": "Corona Australis",
    "id": 80,
    "starsOrigin": [
      {
        "name": "HR6942",
        "position": [
          18.539257,
          -39.704001,
          70.2741
        ]
      },
      {
        "name": "λ南冕座",
        "position": [
          18.729706,
          -38.323441,
          62.9327
        ]
      },
      {
        "name": "HR7129",
        "position": [
          18.944582,
          -37.343241,
          131.9261
        ]
      },
      {
        "name": "ε南冕座",
        "position": [
          18.978721,
          -37.107357,
          30.1841
        ]
      },
      {
        "name": "γ南冕座",
        "position": [
          19.106971,
          -37.063437,
          17.304
        ]
      },
      {
        "name": "鳖六",
        "position": [
          19.157869,
          -37.904474,
          38.432
        ]
      },
      {
        "name": "β南冕座",
        "position": [
          19.167154,
          -39.340796,
          145.3488
        ]
      },
      {
        "name": "δ南冕座",
        "position": [
          19.139156,
          -40.496703,
          54.7345
        ]
      },
      {
        "name": "ζ南冕座",
        "position": [
          19.051907,
          -42.095105,
          59.2066
        ]
      },
      {
        "name": "HR7122",
        "position": [
          18.938044,
          -42.710676,
          90.5797
        ]
      }
    ],
    "connRel": [
      [
        8001,
        8002
      ],
      [
        8002,
        8003
      ],
      [
        8003,
        8004
      ],
      [
        8004,
        8005
      ],
      [
        8005,
        8006
      ],
      [
        8006,
        8007
      ],
      [
        8007,
        8008
      ],
      [
        8008,
        8009
      ],
      [
        8009,
        8010
      ]
    ],
    "iconSize": { width: 2800, height: 2800 },
    "iconPosition": 'ε南冕座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "17时58分~19时19分",
    "decRange": "-36.8°~-45.5°",
    "symbol": "南方皇冠",
    "lucida": "南冕座α(鳖六)",
    "area": "128km²",
    "containedStars": "14",
    "bestObs": "6-8月"
  },
  {
    "name": "雕具座",
    "latinName": "Caelum",
    "id": 81,
    "starsOrigin": [
      {
        "name": "γ1雕具座",
        "position": [
          5.07344,
          -35.482978,
          55.5864
        ]
      },
      {
        "name": "β雕具座",
        "position": [
          4.700965,
          -37.144297,
          28.6697
        ]
      },
      {
        "name": "α雕具座",
        "position": [
          4.676039,
          -41.863752,
          20.1654
        ]
      },
      {
        "name": "δ雕具座",
        "position": [
          4.513916,
          -44.953749,
          215.9827
        ]
      }
    ],
    "connRel": [
      [
        8101,
        8102
      ],
      [
        8102,
        8103
      ],
      [
        8103,
        8104
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'α雕具座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "4时19分~5时05分",
    "decRange": "-27.0°~48.7°",
    "symbol": "凿子",
    "lucida": "雕具座α(近天园增六)",
    "area": "125km²",
    "containedStars": "8",
    "bestObs": "12-1月"
  },
  {
    "name": "网罟座",
    "latinName": "Reticulum",
    "id": 82,
    "starsOrigin": [
      {
        "name": "δ网罟座",
        "position": [
          3.979095,
          -61.400185,
          161.2903
        ]
      },
      {
        "name": "β网罟座",
        "position": [
          3.736593,
          -64.806903,
          29.8597
        ]
      },
      {
        "name": "α网罟座",
        "position": [
          4.240404,
          -62.473858,
          49.554
        ]
      },
      {
        "name": "ε网罟座",
        "position": [
          4.274738,
          -59.302156,
          18.2382
        ]
      },
      {
        "name": "ι网罟座",
        "position": [
          4.021697,
          -61.078822,
          97.8474
        ]
      }
    ],
    "connRel": [
      [
        8201,
        8202
      ],
      [
        8202,
        8203
      ],
      [
        8203,
        8204
      ],
      [
        8204,
        8205
      ],
      [
        8205,
        8201
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": 'ι网罟座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "3时13分~4时37分",
    "decRange": "-52.8°~-67°",
    "symbol": "网",
    "lucida": "网罟座α(夹白二)",
    "area": "114km²",
    "containedStars": "11",
    "bestObs": "11-1月"
  },
  {
    "name": "南三角座",
    "latinName": "Triangulum Australe",
    "id": 83,
    "starsOrigin": [
      {
        "name": "α南三角座",
        "position": [
          16.811077,
          -69.027715,
          119.7605
        ]
      },
      {
        "name": "γ南三角座@1",
        "position": [
          15.315181,
          -68.679545,
          56.3698
        ]
      },
      {
        "name": "ε南三角座",
        "position": [
          15.612,
          -66.317037,
          61.8429
        ]
      },
      {
        "name": "β南三角座",
        "position": [
          15.919083,
          -63.430727,
          12.3778
        ]
      }
    ],
    "connRel": [
      [
        8301,
        8302
      ],
      [
        8302,
        8303
      ],
      [
        8303,
        8304
      ],
      [
        8304,
        8301
      ]
    ],
    "iconSize": { width: 3000, height: 3000 },
    "iconPosition": 'ε南三角座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "14时56分~17时13分",
    "decRange": "-60°~-70°",
    "symbol": "南天的三角形",
    "lucida": "南三角座α(三角形三)",
    "area": "110km²",
    "containedStars": "10",
    "bestObs": "5-7月"
  },
  {
    "name": "盾牌座",
    "latinName": "Scutum",
    "id": 84,
    "starsOrigin": [
      {
        "name": "β盾牌座",
        "position": [
          18.786242,
          -4.747867,
          280.8989
        ]
      },
      {
        "name": "α盾牌座",
        "position": [
          18.586785,
          -8.244073,
          61.0501
        ]
      },
      {
        "name": "γ盾牌座",
        "position": [
          18.486626,
          -14.565813,
          97.9432
        ]
      },
      {
        "name": "HR7119",
        "position": [
          18.911976,
          -15.603036,
          429.1845
        ]
      }
    ],
    "connRel": [
      [
        8401,
        8402
      ],
      [
        8402,
        8403
      ],
      [
        8403,
        8404
      ],
      [
        8404,
        8401
      ]
    ],
    "iconSize": { width: 4000, height: 4000 },
    "iconPosition": 'β盾牌座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "18时21分~18时59分",
    "decRange": "-4°~-16.1°",
    "symbol": "盾牌",
    "lucida": "盾牌座α(天弁一)",
    "area": "109km²",
    "containedStars": "7",
    "bestObs": "7-8月"
  },
  {
    "name": "圆规座",
    "latinName": "Circinus",
    "id": 85,
    "starsOrigin": [
      {
        "name": "γ圆规座",
        "position": [
          15.389625,
          -59.320787,
          137.5516
        ]
      },
      {
        "name": "α圆规座",
        "position": [
          14.708492,
          -64.975138,
          16.57
        ]
      },
      {
        "name": "β圆规座",
        "position": [
          15.291917,
          -58.801208,
          30.553
        ]
      }
    ],
    "connRel": [
      [
        8501,
        8502
      ],
      [
        8502,
        8503
      ]
    ],
    "iconSize": { width: 2600, height: 2600 },
    "iconPosition": 'α圆规座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "13时38分~15时30分",
    "decRange": "-55.7°~-70.6°",
    "symbol": "圆规",
    "lucida": "圆规座α(南门增二)",
    "area": "93km²",
    "containedStars": "164",
    "bestObs": "4-6月"
  },
  {
    "name": "天箭座",
    "latinName": "Sagitta",
    "id": 86,
    "starsOrigin": [
      {
        "name": "η天箭座",
        "position": [
          20.08597,
          19.991071,
          49.1642
        ]
      },
      {
        "name": "γ天箭座",
        "position": [
          19.979285,
          19.492148,
          79.2393
        ]
      },
      {
        "name": "δ天箭座",
        "position": [
          19.789795,
          18.534286,
          182.1494
        ]
      },
      {
        "name": "β天箭座",
        "position": [
          19.68415,
          17.476041,
          134.7709
        ]
      },
      {
        "name": "左旗一",
        "position": [
          19.668275,
          18.01389,
          130.3781
        ]
      }
    ],
    "connRel": [
      [
        8601,
        8602
      ],
      [
        8602,
        8603
      ],
      [
        8603,
        8604
      ],
      [
        8603,
        8605
      ]
    ],
    "iconSize": { width: 2000, height: 2000 },
    "iconPosition": 'γ天箭座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "18时57分~20时20分",
    "decRange": "16.1°~21.6°",
    "symbol": "箭",
    "lucida": "天箭座γ(左旗五)",
    "area": "80km²",
    "containedStars": "19",
    "bestObs": "7-9月"
  },
  {
    "name": "小马座",
    "latinName": "Equuleus",
    "id": 87,
    "starsOrigin": [
      {
        "name": "β小马座",
        "position": [
          21.381559,
          6.81114,
          101.4199
        ]
      },
      {
        "name": "δ小马座",
        "position": [
          21.241337,
          10.006981,
          18.4877
        ]
      },
      {
        "name": "γ小马座",
        "position": [
          21.172361,
          10.131579,
          36.2976
        ]
      },
      {
        "name": "虚宿二",
        "position": [
          21.263731,
          5.247845,
          58.3431
        ]
      }
    ],
    "connRel": [
      [
        8701,
        8702
      ],
      [
        8702,
        8703
      ],
      [
        8703,
        8704
      ],
      [
        8704,
        8701
      ]
    ],
    "iconSize": { width: 2800, height: 2800 },
    "iconPosition": 'β小马座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "20时56分~21时26分",
    "decRange": "2.4°~12.8°",
    "symbol": "马驹",
    "lucida": "小马座α(虚宿二)",
    "area": "72km²",
    "containedStars": "10",
    "bestObs": "8-10月"
  },
  {
    "name": "南十字座",
    "latinName": "Crux",
    "id": 88,
    "starsOrigin": [
      {
        "name": "十字架一",
        "position": [
          12.519429,
          -57.113212,
          27.1518
        ]
      },
      {
        "name": "十字架二",
        "position": [
          12.443311,
          -63.099092,
          98.7167
        ]
      },
      {
        "name": "十字架三",
        "position": [
          12.795359,
          -59.688764,
          85.3971
        ]
      },
      {
        "name": "δ南十字座",
        "position": [
          12.252427,
          -58.748928,
          105.8201
        ]
      }
    ],
    "connRel": [
      [
        8801,
        8802
      ],
      [
        8803,
        8804
      ]
    ],
    "iconSize": { width: 2800, height: 2800 },
    "iconPosition": 'δ南十字座',
    "labelPositionIdx": 1,
    "color": "red",
    "raRange": "11时56分~12时58分",
    "decRange": "-55.7°~-64.7°",
    "symbol": "十字架",
    "lucida": "南十字座α(十字架二)",
    "area": "68km²",
    "containedStars": "10",
    "bestObs": "3-5月"
  }
];

export default constellations;
